import { create } from "zustand";
import { _Componentes_WebApiCalls_Post } from "../../ComponentesGlobales/WebApiCalls";
import { useStoreHome } from "../Home/useStoreHome";
import {
  MensajeError,
  MensajeInfo,
  MensajeToastAdvertencia,
  MensajeToastExito,
} from "../../componentes/FuncionesLocales";
import { crearRequestMercaderiasPiSeun, evaluarFiltrosMercaderia } from "../../servicios/mercaderiasPiSeun";
import { obtenerPcIdActual } from "../../servicios/configuracionPc";
import {
  descargarComprobante,
  consultarEstadoFactura,
  emitirFacturaElectronica,
  esEstadoEmitible,
  ESTADOS_ARCA,
  ESTADOS_VENTA,
  generarUuid,
  mensajeSeguro,
  normalizarEstadoFiscal,
  normalizarDocumentoVenta,
  normalizarResultadoVenta,
  obtenerComprobanteDatos,
  obtenerPendientesArca,
  POLITICAS_FACTURACION,
  reintentarFacturaElectronica,
} from "../../servicios/facturacionElectronica";
import {
  calcularVentaResumen,
  calcularVentaLinea,
  guardarResultadoPendiente,
  limpiarVentaPendiente,
  obtenerVentaPendiente,
  redondearMoneda,
  resolverIdempotencia,
  validarVenta,
} from "../../servicios/ventas";
import {
  consultarIvaMercaderia,
  mensajeVentaConIvaFaltante,
} from "../../servicios/mercaderiasIva";
import {
  insertarClienteVenta,
  insertarVenta,
  obtenerConsumidorFinal,
  obtenerDocumentoVenta,
  obtenerCondicionesIvaCliente,
  obtenerOpcionesFacturacion,
  obtenerPagosVenta,
  obtenerPrecioVenta,
  obtenerTiposDocumentoCliente,
  obtenerUltimasVentas,
  extraerUltimasVentas,
} from "../../servicios/ventasApi";
import {
  actualizarPago,
  agregarPago,
  crearPago,
  crearPagoInicial,
  eliminarPago,
  esCuentaCorriente,
  filtrarFormasPagoConsumidorFinal,
  normalizarFormaPago,
  obtenerFormaPagoInicial,
  resumirPagos,
  sincronizarPagosConTotal,
  validarPagos,
} from "../../servicios/pagosVenta";
import {
  analizarComprobacionFiscal,
  admiteCompraComoConsumidorFinal,
  clienteTieneCuit,
  crearFacturacionVenta,
  descripcionCondicionIva,
  normalizarConsumidorFinal,
  normalizarClienteSeleccion,
  normalizarOpcionesFacturacion,
  validarClienteNuevo,
} from "../../servicios/facturacionFiscal";
import { obtenerFacturaHistorial } from "../../servicios/comprobantesApi";
import {
  actualizarCliente as actualizarClienteApi,
  eliminarCliente as eliminarClienteApi,
  invalidarCacheClientes,
  listarClientes,
  normalizarClienteEditable,
  obtenerCliente,
  reemplazarClienteEnCache,
} from "../../servicios/clientes";
import {
  actualizarPreciosRapidos,
  listarListasPrecios,
  obtenerMercaderiasLista,
} from "../../servicios/listasPreciosApi";
import { listarCatalogoMercaderias } from "../../servicios/mercaderiasApi";
import {
  calcularNetoDesdePrecioFinal,
  esCategoriaFiscalValida,
  listarCategoriasFiscales,
} from "../../servicios/categoriasFiscales";
import {
  crearContenidoComercialVenta,
  crearEntradaVenta,
  crearRequestVenta,
} from "../../servicios/ventasRequest";
import { obtenerOperadorIdActual } from "../../servicios/contextoSesion";
import { useStoreCajas } from "../Cajas/useStoreCajas";
import { esErrorSesionCaja, sesionAbierta } from "../../servicios/cajas";

let claveMercaderiasPos = null;
let secuenciaMercaderiasPos = 0;
let ventaEnCurso = false;
const facturasReintentando = new Set();
let solicitudOpcionesFacturacion = 0;
let abortOpcionesFacturacion = null;
let solicitudConsumidorFinal = 0;
let abortConsumidorFinal = null;
let solicitudClientesPos = 0;
let solicitudClienteEditable = 0;
let solicitudVentasRecientes = 0;
let abortVentasRecientes = null;

const esProductoNuevoLinea = (linea) =>
  Boolean(linea?.ProductoNuevo || linea?.TipoLinea === "Libre");

export const estimarStockTicket = (lineas = []) => {
  const consumidoPorMercaderia = new Map();

  return lineas.map((linea) => {
    if (esProductoNuevoLinea(linea)) {
      const cantidad = Math.max(0, Number(linea.Cantidad) || 0);
      return {
        ...linea,
        EstadoStockEstimado: "SinStock",
        CantidadStockEstimada: 0,
        CantidadSinStockEstimada: cantidad,
        VentaSinStock: cantidad > 0,
      };
    }

    const mercaderiaId = Number(linea.Mercaderia?.Id) || 0;
    const cantidad = Math.max(0, Number(linea.Cantidad) || 0);
    const disponible = Math.max(0, Number(linea.Mercaderia?.sExtra) || 0);
    const controlaStock = !!linea.Mercaderia?.bLlevaStock || disponible > 0;
    if (!controlaStock || mercaderiaId <= 0) {
      return {
        ...linea,
        EstadoStockEstimado: "NoAplica",
        CantidadStockEstimada: 0,
        CantidadSinStockEstimada: 0,
        VentaSinStock: false,
      };
    }

    const consumido = consumidoPorMercaderia.get(mercaderiaId) || 0;
    const cantidadStock = Math.min(cantidad, Math.max(0, disponible - consumido));
    const cantidadSinStock = Math.max(0, cantidad - cantidadStock);
    consumidoPorMercaderia.set(mercaderiaId, consumido + cantidadStock);

    return {
      ...linea,
      EstadoStockEstimado:
        cantidadSinStock === 0 ? "Completo" : cantidadStock > 0 ? "Parcial" : "SinStock",
      CantidadStockEstimada: cantidadStock,
      CantidadSinStockEstimada: cantidadSinStock,
      VentaSinStock: cantidadSinStock > 0,
    };
  });
};

export const aplicarResultadoStockVenta = (venta = {}, detalleStock = []) => {
  const porLinea = new Map(detalleStock.map((item) => [Number(item.linea), item]));
  return {
    ...venta,
    DetalleStock: detalleStock,
    lstDetalle: (venta.lstDetalle || []).map((linea, indice) => {
      const stock = porLinea.get(indice + 1);
      if (!stock) return linea;
      return {
        ...linea,
        Mercaderia_Id: Number(stock.mercaderiaId) || Number(linea.Mercaderia_Id) || 0,
        bCatalogado: Number(stock.mercaderiaId) > 0 || !!linea.bCatalogado,
        CrearCatalogo: Number(stock.mercaderiaId) > 0 ? false : !!linea.CrearCatalogo,
        EstadoStock: stock.estadoStock,
        CantidadStockConsumida: stock.cantidadStockConsumida,
        CantidadSinStock: stock.cantidadSinStock,
        VentaSinStock: stock.cantidadSinStock > 0,
      };
    }),
  };
};

export const agregarVentaReciente = (ventas = [], venta, limite = 10) => {
  if (!venta) return Array.isArray(ventas) ? ventas : [];
  const ventaId = Number(venta.VentaId) || 0;
  const lista = Array.isArray(ventas) ? ventas : [];
  const sinDuplicado = lista.filter((item) => {
    if (ventaId > 0) return Number(item?.VentaId) !== ventaId;
    return item?.dFecha !== venta.dFecha;
  });
  return [venta, ...sinDuplicado].slice(0, limite);
};

const fechaISO = (fecha = new Date()) => {
  const date = new Date(fecha);
  const offset = date.getTimezoneOffset();
  return new Date(date.getTime() - offset * 60000).toISOString().slice(0, 10);
};

const obtenerConfiguracionFacturacion = (
  numeradorId,
  formaPagoId,
  solicitaIdentificacionFiscal,
  facturarComoConsumidorFinal
) => {
  const diasVencimiento = Number(localStorage.getItem("PosFacturaDiasVencimiento")) || 0;
  const fechaVenta = new Date();
  const fechaVencimiento = new Date(fechaVenta);
  fechaVencimiento.setDate(fechaVencimiento.getDate() + diasVencimiento);
  return crearFacturacionVenta({
    NumeradorId: Number(numeradorId) || 0,
    SolicitaIdentificacionFiscal: Boolean(solicitaIdentificacionFiscal),
    FacturarComoConsumidorFinal: Boolean(facturarComoConsumidorFinal),
    FormaPagoId: Number(formaPagoId) || 0,
    CuentaCorrienteId: Number(localStorage.getItem("PosFacturaCuentaCorrienteId")) || 0,
    FechaFactura: fechaISO(fechaVenta),
    FechaVencimiento: fechaISO(fechaVencimiento),
  });
};

const guardarArchivo = (blob, nombre) => {
  const url = URL.createObjectURL(blob);
  const enlace = document.createElement("a");
  enlace.href = url;
  enlace.download = nombre;
  document.body.appendChild(enlace);
  enlace.click();
  enlace.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

const obtenerNumero = (...valores) => {
  for (const valor of valores) {
    if (valor === undefined || valor === null || valor === "") continue;
    const numero = Number(valor);
    if (Number.isFinite(numero)) return numero;
  }
  return null;
};

const obtenerPrecio = (origen) => {
  const dato = origen?.Dato;
  const primerLista = Array.isArray(origen?.Lista) ? origen.Lista[0] : null;
  const primerData = Array.isArray(origen?.data) ? origen.data[0] : null;

  return obtenerNumero(
    origen?.nPrecio,
    origen?.PrecioUnitario,
    origen?.Precio,
    origen?.precio,
    dato?.nPrecio,
    dato?.PrecioUnitario,
    dato?.Precio,
    dato,
    primerLista?.nPrecio,
    primerLista?.PrecioUnitario,
    primerLista?.Precio,
    primerData?.nPrecio,
    primerData?.PrecioUnitario,
    primerData?.Precio
  );
};

const fechaYYYYMMDD = (fecha = new Date()) => {
  const date = new Date(fecha);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}${month}${day}`;
};

const numeroLegacy = (valor) => String(Number(valor) || 0).replace(",", ".");

const limpiarCampoLegacy = (valor) =>
  String(valor ?? "")
    .replace(/[@,\r\n]/g, " ")
    .trim();

const getOperadorId = obtenerOperadorIdActual;

const getPcId = obtenerPcIdActual;

const obtenerClienteFacturacionId = (estado) =>
  Number(estado.Cliente?.Id) || Number(estado.ClienteConsumidorFinalId) || 0;
// El cliente generico de Consumidor Final es necesario para facturar, pero no
// representa una asignacion particular de lista de precios. Sin un cliente
// seleccionado, GetPrecioPiSeun debe recibir cero para resolver la lista general.
const obtenerClientePrecioId = (estado) => Number(estado.Cliente?.Id) || 0;
const obtenerClienteRequestId = (estado) =>
  estado.ModoCliente === "cliente"
    ? Number(estado.Cliente?.Id) || 0
    : Number(estado.ClienteConsumidorFinalId) || 0;
const obtenerFormasPagoPermitidas = (estado) => filtrarFormasPagoConsumidorFinal(
  estado.ListaFormasPago,
  estado.ModoCliente === "consumidorFinal"
);
const crearClaveContextoConsumidorFinal = () => JSON.stringify({
  EmpresaId: useStoreHome.getState().EmpresaId || 0,
});
const obtenerTotalFiscal = (estado) => calcularVentaResumen(estado.TicketLineas).TotalConIva;
const crearClaveEvaluacionFiscal = (estado) => JSON.stringify({
  EmpresaId: useStoreHome.getState().EmpresaId || 0,
  clienteId: obtenerClienteRequestId(estado),
  totalCentavos: Math.round(obtenerTotalFiscal(estado) * 100),
  solicitaIdentificacionFiscal: Boolean(estado.SolicitaIdentificacionFiscal),
  facturarComoConsumidorFinal: Boolean(estado.FacturarComoConsumidorFinal),
});

const crearCodigoExternoPos = () => {
  const now = new Date();
  const hora = [
    String(now.getHours()).padStart(2, "0"),
    String(now.getMinutes()).padStart(2, "0"),
    String(now.getSeconds()).padStart(2, "0"),
  ].join("");
  return `POS-${fechaYYYYMMDD(now)}-${hora}`;
};

const construirResumenLegacy = ({ clienteId, observacion, operadorId, amparoId = 3 }) => {
  const fecha = fechaYYYYMMDD();
  const codigoExterno = crearCodigoExternoPos();

  return [
    0,
    clienteId,
    fecha,
    codigoExterno,
    1,
    1,
    0,
    amparoId,
    0,
    0,
    "",
    "",
    limpiarCampoLegacy(observacion),
    operadorId,
    1,
    1,
    "",
    "",
    fecha,
    0,
    0,
    0,
    0,
    0,
    codigoExterno,
    0,
    0,
    0,
    0,
    1,
    0,
  ].join("@");
};

const construirDetalleLegacy = async ({ lineas, EmpresaId }) => {
  const fecha = fechaYYYYMMDD();
  const detalle = [];

  for (let index = 0; index < lineas.length; index += 1) {
    const linea = lineas[index];
    const esProductoNuevo = esProductoNuevoLinea(linea);
    const mercaderiaId = Number(linea.Mercaderia?.Id) || 0;
    let unidadId = Number(
      linea.Unidad?.Id ||
      linea.Mercaderia?.MercaderiaUnidad_Id ||
      linea.Mercaderia?.UnidadId ||
      0
    );

    if (!unidadId && !esProductoNuevo && mercaderiaId) {
      const unidad = await _Componentes_WebApiCalls_Post("Mercaderias/GetUnidadPorMercaderia", {
        EmpresaId,
        Id: mercaderiaId,
      });

      if (unidad.error) {
        return { error: unidad.error };
      }

      unidadId = Number(unidad.data?.Id) || 0;
    }

    if ((!esProductoNuevo && !mercaderiaId) || !unidadId) {
      return {
        error: esProductoNuevo
          ? "Debe seleccionar la unidad de medida del producto nuevo."
          : "No se pudo obtener la unidad de una mercaderia del ticket.",
      };
    }

    detalle.push(
      [
        0,
        mercaderiaId,
        unidadId,
        numeroLegacy(linea.Cantidad),
        0,
        0,
        fecha,
        fecha,
        fecha,
        fecha,
        0,
        0,
        "",
        index + 1,
        0,
        numeroLegacy(linea.PrecioUnitario),
        0,
        0,
        0,
      ].join("@")
    );
  }

  return { detalle: detalle.join(",") };
};

const defaultVentaState = {
  FormaPago: "",
  FormaPagoId: 0,
  MontoRecibido: 0,
  Pagos: [],
  FormaFiscalPrincipalId: 0,
  Observacion: "",
};

const crearCatalogoLineaDesdeVenta = (linea, detalleId, indice) => {
  const descripcion = String(linea?.DescripcionManual || linea?.Mercaderia?.sDescripcion || "").trim();
  const unidadDescripcion = String(
    linea?.Unidad?.sDescripcion ||
    linea?.Unidad_Descripcion ||
    linea?.Mercaderia?.UnidadDescripcion ||
    linea?.Mercaderia?.sUnidad ||
    "Unidad"
  ).trim() || "Unidad";
  const unidadId = Number(
    linea?.Unidad?.Id ||
    linea?.Unidad_Id ||
    linea?.Mercaderia?.MercaderiaUnidad_Id ||
    linea?.Mercaderia?.UnidadId ||
    0
  );
  const tipoMercaderiaId = esProductoNuevoLinea(linea)
    ? 16
    : Number(linea?.Mercaderia?.MercaderiaTipo_Id || 5) || 5;

  return {
    DetalleId: Number(detalleId) || 0,
    Indice: Number(indice) || 0,
    Descripcion: descripcion,
    Unidad: {
      Id: unidadId,
      sCodigo: linea?.Unidad?.sCodigo || linea?.Unidad_Codigo || unidadDescripcion,
      sDescripcion: unidadDescripcion,
    },
    MercaderiaTipoId: tipoMercaderiaId,
    LlevaStock: esProductoNuevoLinea(linea) ? true : !!linea?.Mercaderia?.bLlevaStock,
    CantidadEstandar: Math.max(1, Math.round(Number(linea?.Cantidad) || 1)),
    PesoEstandar: 0,
    VencimientoCantidad: Number(linea?.Mercaderia?.VencimientoCantidad) || 0,
    VencimientoPorDia: false,
  };
};

const ventaPendienteInicial = obtenerVentaPendiente();

const estadoFacturaLocalDesdeResultado = (resultado = {}) => {
  if (resultado.ivaPendiente || resultado.estadoVenta === ESTADOS_VENTA.PENDIENTE_IVA) return "pendiente-iva";
  if (resultado.estadoVenta === ESTADOS_VENTA.ERROR_FACTURA_LOCAL) return "error";
  return Number(resultado.facturaId) > 0 ? "creada" : "pendiente";
};

const requiereReconciliarDocumentos = (resultado = {}) =>
  resultado.estadoVenta === ESTADOS_VENTA.PENDIENTE_IVA ||
  resultado.estadoVenta === ESTADOS_VENTA.PENDIENTE_FACTURACION ||
  resultado.estadoVenta === ESTADOS_VENTA.ERROR_FACTURA_LOCAL;

const perteneceAlContextoActual = (pendiente, EmpresaId) =>
  Number(pendiente?.request?.EmpresaId) === Number(EmpresaId) &&
  Number(EmpresaId) > 0;

export const useStorePos = create((set, get) => {
  return {
    // ---------- Cliente ----------
    Cliente: null,
    ModoCliente: "consumidorFinal",
    ClienteConsumidorFinalId: 0,
    ConsumidorFinalCodigo: "",
    ConsumidorFinalDescripcion: "",
    ConsumidorFinalContextoClave: "",
    CargandoConsumidorFinal: false,
    ErrorConsumidorFinal: "",
    SolicitaIdentificacionFiscal: false,
    FacturarComoConsumidorFinal: false,
    MontoConsumidorFinalSinIdentificar: 0,
    RequiereIdentificacionFiscal: false,
    EsConsumidorFinalGenerico: false,
    ClienteSeleccionRequerida: false,
    EvaluacionFiscalClave: "",
    ListaClientes: [],
    BuscandoClientes: false,
    ClientesBase: "",
    ErrorClientes: "",
    ClienteNuevoVisible: false,
    ClienteNuevoNombre: "",
    ClienteEdicionId: 0,
    ClienteEditable: null,
    CargandoClienteEditable: false,
    TiposDocumento: [],
    TiposDocumentoBase: "",
    CargandoTiposDocumento: false,
    CondicionesIVA: [],
    CondicionesIVABase: "",
    CargandoCondicionesIVA: false,
    GuardandoCliente: false,
    EliminandoClienteId: 0,
    OpcionesFacturacion: [],
    NumeradorId: 0,
    CargandoOpcionesFacturacion: false,
    ErrorOpcionesFacturacion: "",
    CondicionIVASeleccionada: "",
    ComprobacionFiscalVisible: false,
    CargandoComprobacionFiscal: false,
    ComprobacionFiscal: null,

    getClientes: async ({ forzar = false } = {}) => {
      const base = useStoreHome.getState().EmpresaId;
      if (!base) return [];
      const miSolicitud = ++solicitudClientesPos;
      set({
        BuscandoClientes: true,
        ErrorClientes: "",
        ...(get().ClientesBase !== base
          ? {
              ListaClientes: [],
              Cliente: null,
              ClienteConsumidorFinalId: 0,
              ConsumidorFinalCodigo: "",
              ConsumidorFinalDescripcion: "",
              ConsumidorFinalContextoClave: "",
              ErrorConsumidorFinal: "",
              ModoCliente: "consumidorFinal",
            }
          : {}),
        ClientesBase: base,
      });
      try {
        const respuesta = await listarClientes({ EmpresaId: base, forzar });
        if (miSolicitud !== solicitudClientesPos || useStoreHome.getState().EmpresaId !== base) return [];
        if (respuesta.error) {
          set({ ListaClientes: [], ErrorClientes: respuesta.error });
          MensajeError(respuesta.error);
          return [];
        }
        const lista = respuesta.data?.Lista || [];
        set({
          ListaClientes: lista,
        });
        return lista;
      } catch (error) {
        if (miSolicitud === solicitudClientesPos) {
          set({ ListaClientes: [], ErrorClientes: error.message });
        }
        MensajeError(error.message);
        return [];
      } finally {
        if (miSolicitud === solicitudClientesPos && useStoreHome.getState().EmpresaId === base) {
          set({ BuscandoClientes: false });
        }
      }
    },

    cargarConsumidorFinal: async ({ cargarOpciones = true, forzar = false } = {}) => {
      const EmpresaId = useStoreHome.getState().EmpresaId;
      const claveContexto = crearClaveContextoConsumidorFinal();
      const estadoActual = get();

      if (
        !forzar &&
        estadoActual.ConsumidorFinalContextoClave === claveContexto &&
        estadoActual.ClienteConsumidorFinalId > 0
      ) {
        return cargarOpciones ? get().cargarOpcionesFacturacion() : true;
      }

      const miSolicitud = ++solicitudConsumidorFinal;
      abortConsumidorFinal?.abort();
      abortConsumidorFinal = null;
      set({
        ClienteConsumidorFinalId: 0,
        ConsumidorFinalCodigo: "",
        ConsumidorFinalDescripcion: "",
        ConsumidorFinalContextoClave: "",
        MontoConsumidorFinalSinIdentificar: 0,
        CargandoConsumidorFinal: false,
        ErrorConsumidorFinal: "",
        OpcionesFacturacion: [],
        NumeradorId: 0,
        ErrorOpcionesFacturacion: "",
        EvaluacionFiscalClave: "",
      });

      if (!EmpresaId || EmpresaId <= 0) {
        const error = !EmpresaId
          ? "No se encontro la conexion a la base de datos."
          : "No se encontro una empresa activa para resolver Consumidor Final.";
        set({ ErrorConsumidorFinal: error, ErrorOpcionesFacturacion: error });
        return false;
      }

      abortConsumidorFinal = new AbortController();
      set({ CargandoConsumidorFinal: true });
      const respuesta = await obtenerConsumidorFinal(
        { EmpresaId },
        { signal: abortConsumidorFinal.signal }
      );
      if (
        miSolicitud !== solicitudConsumidorFinal ||
        crearClaveContextoConsumidorFinal() !== claveContexto
      ) return false;
      abortConsumidorFinal = null;
      if (respuesta.aborted) return false;

      if (respuesta.error) {
        const error = mensajeSeguro(
          respuesta.error,
          "No se pudo resolver el cliente Consumidor Final."
        );
        set({
          CargandoConsumidorFinal: false,
          ErrorConsumidorFinal: error,
          ErrorOpcionesFacturacion: error,
        });
        return false;
      }

      const consumidorFinal = normalizarConsumidorFinal(respuesta.data);
      const error = consumidorFinal.Error ||
        (consumidorFinal.ClienteConsumidorFinalId <= 0
          ? "No existe un cliente Consumidor Final configurado para la empresa activa."
          : "");
      if (error) {
        set({
          CargandoConsumidorFinal: false,
          ErrorConsumidorFinal: error,
          ErrorOpcionesFacturacion: error,
        });
        return false;
      }

      set({
        ClienteConsumidorFinalId: consumidorFinal.ClienteConsumidorFinalId,
        ConsumidorFinalCodigo: consumidorFinal.Codigo,
        ConsumidorFinalDescripcion: consumidorFinal.Descripcion,
        ConsumidorFinalContextoClave: claveContexto,
        MontoConsumidorFinalSinIdentificar: consumidorFinal.MontoSinIdentificar,
        CargandoConsumidorFinal: false,
        ErrorConsumidorFinal: "",
      });
      return cargarOpciones ? get().cargarOpcionesFacturacion() : true;
    },

    setCliente: async (Cliente) => {
      const clienteId = Number(Cliente?.Id) || 0;
      const modoCliente = clienteId > 0 ? "cliente" : "consumidorFinal";
      if (clienteId > 0 && clienteId === Number(get().ClienteConsumidorFinalId)) {
        return get().setConsumidorFinal();
      }
      const actuales = get().TicketLineas.map((linea) =>
        esProductoNuevoLinea(linea)
          ? linea
          : { ...linea, PrecioVigente: false, ErrorPrecio: "Actualizando precio para el cliente seleccionado." }
      );
      const actualizarPrecioEditor = Boolean(
        get().Mercaderia && typeof get().Mercaderia === "object" && Number(get().Mercaderia.Id) > 0
      );
      const catalogoPermitido = filtrarFormasPagoConsumidorFinal(
        get().ListaFormasPago,
        modoCliente === "consumidorFinal"
      );
      const formaPagoSeleccionada = catalogoPermitido.find(
        (formaPago) => formaPago.Id === Number(get().FormaPagoId)
      ) || obtenerFormaPagoInicial(catalogoPermitido);
      const pagos = (get().Pagos || []).map((pago) => {
        const permitida = catalogoPermitido.find((formaPago) => formaPago.Id === Number(pago.FormaPagoId));
        return pago.FormaPagoId && !permitida
          ? { ...pago, FormaPagoId: 0, FormaPago: "" }
          : pago;
      });
      const formaFiscalPermitida = catalogoPermitido.some(
        (formaPago) => formaPago.Id === Number(get().FormaFiscalPrincipalId)
      );
      set({
        Cliente,
        ModoCliente: modoCliente,
        FacturarComoConsumidorFinal: false,
        TicketLineas: actuales,
        ErroresLineas: {},
        OpcionesFacturacion: [],
        NumeradorId: 0,
        ErrorOpcionesFacturacion: "",
        CondicionIVASeleccionada: "",
        RequiereIdentificacionFiscal: false,
        ClienteSeleccionRequerida: false,
        EvaluacionFiscalClave: "",
        Pagos: pagos,
        FormaPagoId: formaPagoSeleccionada?.Id || 0,
        FormaPago: formaPagoSeleccionada?.sDescripcion || "",
        FormaFiscalPrincipalId: formaFiscalPermitida ? get().FormaFiscalPrincipalId : 0,
        ...(actualizarPrecioEditor
          ? {
              PrecioUnitario: 0,
              BuscandoPrecio: true,
              ErrorPrecio: "",
              IvaMercaderia: null,
            }
          : {}),
      });
      const consultaPrecioEditor = actualizarPrecioEditor
        ? get().getPrecio()
        : Promise.resolve();
      const opcionesOk = await get().cargarOpcionesFacturacion();
      if (!opcionesOk && obtenerClientePrecioId(get()) !== clienteId) return;

      const EmpresaId = useStoreHome.getState().EmpresaId;
      const precioClienteId = obtenerClientePrecioId(get());
      const totalAntesDePrecios = calcularVentaResumen(actuales).TotalConIva;
      const actualizadas = await Promise.all(actuales.map(async (linea) => {
        if (esProductoNuevoLinea(linea)) return linea;
        const mercaderiaId = Number(linea.Mercaderia?.Id) || 0;
        const respuesta = await obtenerPrecioVenta({
          EmpresaId,
          ClienteId: precioClienteId,
          MercaderiaId: mercaderiaId,
        });
        if (respuesta.error) {
          return { ...linea, PrecioVigente: false, ErrorPrecio: `Sin precio vigente: ${respuesta.error}` };
        }
        const precio = obtenerPrecio(respuesta.data);
        if (precio === null) {
          return { ...linea, PrecioVigente: false, ErrorPrecio: "No existe un precio vigente para este cliente." };
        }
        const calculo = calcularVentaLinea({ ...linea, PrecioUnitario: precio });
        return {
          ...linea,
          PrecioUnitario: precio,
          Subtotal: calculo.subtotal,
          PrecioClienteId: precioClienteId,
          PrecioVigente: true,
          ErrorPrecio: "",
        };
      }));

      if (obtenerClientePrecioId(get()) === clienteId) {
        set({ TicketLineas: actualizadas, ErroresLineas: validarVenta(actualizadas).erroresLineas });
        const errores = actualizadas.filter((linea) => linea.PrecioVigente === false);
        if (errores.length) MensajeError("Uno o mas productos no tienen precio vigente para el cliente seleccionado.");
        const totalDespuesDePrecios = calcularVentaResumen(actualizadas).TotalConIva;
        if (Math.round(totalAntesDePrecios * 100) !== Math.round(totalDespuesDePrecios * 100)) {
          await get().cargarOpcionesFacturacion({ preservarNumeradorId: get().NumeradorId });
        }
      }
      await consultaPrecioEditor;
    },

    setConsumidorFinal: async () => get().setCliente(null),

    setSolicitaIdentificacionFiscal: async (SolicitaIdentificacionFiscal) => {
      set({
        SolicitaIdentificacionFiscal: Boolean(SolicitaIdentificacionFiscal),
        OpcionesFacturacion: [],
        NumeradorId: 0,
        ErrorOpcionesFacturacion: "",
        RequiereIdentificacionFiscal: false,
        ClienteSeleccionRequerida: false,
        EvaluacionFiscalClave: "",
      });
      return get().cargarOpcionesFacturacion();
    },

    setFacturarComoConsumidorFinal: async (FacturarComoConsumidorFinal) => {
      const estado = get();
      const habilitado = estado.ModoCliente === "cliente" &&
        admiteCompraComoConsumidorFinal(estado.Cliente, estado.CondicionesIVA);
      set({
        FacturarComoConsumidorFinal: habilitado && Boolean(FacturarComoConsumidorFinal),
        OpcionesFacturacion: [],
        NumeradorId: 0,
        ErrorOpcionesFacturacion: "",
        CondicionIVASeleccionada: "",
        RequiereIdentificacionFiscal: false,
        ClienteSeleccionRequerida: false,
        EvaluacionFiscalClave: "",
      });
      return get().cargarOpcionesFacturacion();
    },

    cargarOpcionesFacturacion: async (configuracion = {}) => {
      const { preservarNumeradorId = 0 } = configuracion || {};
      if (
        get().ConsumidorFinalContextoClave !== crearClaveContextoConsumidorFinal() ||
        get().ClienteConsumidorFinalId <= 0
      ) {
        const consumidorFinalOk = await get().cargarConsumidorFinal({ cargarOpciones: false });
        if (!consumidorFinalOk) return false;
      }
      const estadoSolicitud = get();
      const clienteId = obtenerClienteRequestId(estadoSolicitud);
      const EmpresaId = useStoreHome.getState().EmpresaId;
      const totalOperacion = obtenerTotalFiscal(estadoSolicitud);
      const solicitaIdentificacionFiscal = Boolean(estadoSolicitud.SolicitaIdentificacionFiscal);
      const facturarComoConsumidorFinal = Boolean(estadoSolicitud.FacturarComoConsumidorFinal);
      const claveSolicitud = crearClaveEvaluacionFiscal(estadoSolicitud);
      const miSolicitud = ++solicitudOpcionesFacturacion;
      abortOpcionesFacturacion?.abort();
      abortOpcionesFacturacion = null;
      set({
        OpcionesFacturacion: [],
        NumeradorId: 0,
        ErrorOpcionesFacturacion: "",
        CondicionIVASeleccionada: "",
        CargandoOpcionesFacturacion: false,
        EvaluacionFiscalClave: "",
      });
      if (!EmpresaId) {
        set({ ErrorOpcionesFacturacion: "No se encontro una empresa activa para consultar la facturacion." });
        return false;
      }
      abortOpcionesFacturacion = new AbortController();
      set({ CargandoOpcionesFacturacion: true });
      const respuesta = await obtenerOpcionesFacturacion(
        {
          EmpresaId,
          ClienteId: clienteId,
          TotalOperacion: totalOperacion,
          SolicitaIdentificacionFiscal: solicitaIdentificacionFiscal,
          FacturarComoConsumidorFinal: facturarComoConsumidorFinal,
        },
        { signal: abortOpcionesFacturacion.signal }
      );
      if (
        miSolicitud !== solicitudOpcionesFacturacion ||
        crearClaveEvaluacionFiscal(get()) !== claveSolicitud
      ) return false;
      abortOpcionesFacturacion = null;
      if (respuesta.aborted) return false;
      if (respuesta.error) {
        set({
          CargandoOpcionesFacturacion: false,
          ErrorOpcionesFacturacion: mensajeSeguro(respuesta.error, "No se pudieron obtener opciones de facturacion."),
        });
        return false;
      }
      const opciones = normalizarOpcionesFacturacion(respuesta.data, clienteId);
      const esConsumidorFinal = get().ModoCliente === "consumidorFinal";
      const idGenerico = get().ClienteConsumidorFinalId;
      const errorConfiguracion = esConsumidorFinal && idGenerico <= 0
        ? "No existe un cliente Consumidor Final configurado para la empresa activa."
        : "";
      const error = opciones.Error ||
        errorConfiguracion ||
        (opciones.Lista.length === 0 ? "No hay un numerador activo compatible con el cliente." : "");
      const numeradorPreservado = opciones.Lista.some(
        (opcion) => opcion.NumeradorId === Number(preservarNumeradorId)
      ) ? Number(preservarNumeradorId) : 0;
      set({
        OpcionesFacturacion: opciones.Lista,
        NumeradorId: error ? 0 : numeradorPreservado || opciones.NumeradorSugeridoId,
        ClienteConsumidorFinalId: idGenerico,
        MontoConsumidorFinalSinIdentificar: opciones.MontoConsumidorFinalSinIdentificar,
        RequiereIdentificacionFiscal: opciones.RequiereIdentificacionFiscal,
        EsConsumidorFinalGenerico: opciones.EsConsumidorFinalGenerico,
        ClienteSeleccionRequerida: esConsumidorFinal && opciones.RequiereIdentificacionFiscal,
        CondicionIVASeleccionada: opciones.CondicionIVA ||
          descripcionCondicionIva(opciones.CondicionIVAId, get().CondicionesIVA),
        ErrorOpcionesFacturacion: error,
        CargandoOpcionesFacturacion: false,
        EvaluacionFiscalClave: claveSolicitud,
      });
      return !error;
    },

    seleccionarNumerador: (NumeradorId) => {
      const id = Number(NumeradorId) || 0;
      set({ NumeradorId: get().OpcionesFacturacion.some((opcion) => opcion.NumeradorId === id) ? id : 0 });
    },

    cargarTiposDocumento: async () => {
      const base = useStoreHome.getState().EmpresaId;
      if (get().CargandoTiposDocumento ||
          (get().TiposDocumentoBase === base && get().TiposDocumento.length))
        return;
      set({ CargandoTiposDocumento: true, TiposDocumento: [], TiposDocumentoBase: base });
      try {
        const respuesta = await obtenerTiposDocumentoCliente({ EmpresaId: base });
        if (get().TiposDocumentoBase !== base) return;
        if (respuesta.error) {
          MensajeError(mensajeSeguro(respuesta.error, "No se pudo cargar el catalogo de tipos de documento."));
          return;
        }
        set({ TiposDocumento: Array.isArray(respuesta.data?.Lista) ? respuesta.data.Lista : [] });
      } finally {
        set({ CargandoTiposDocumento: false });
      }
    },

    cargarCondicionesIVA: async () => {
      const base = useStoreHome.getState().EmpresaId;
      if (get().CargandoCondicionesIVA ||
          (get().CondicionesIVABase === base && get().CondicionesIVA.length))
        return;
      set({ CargandoCondicionesIVA: true, CondicionesIVA: [], CondicionesIVABase: base });
      try {
        const respuesta = await obtenerCondicionesIvaCliente({
          EmpresaId: base,
        });
        if (get().CondicionesIVABase !== base) return;
        if (respuesta.error) {
          MensajeError(mensajeSeguro(respuesta.error, "No se pudo cargar el catalogo de condiciones frente al IVA."));
          return;
        }
        set({ CondicionesIVA: Array.isArray(respuesta.data?.Lista) ? respuesta.data.Lista : [] });
      } finally {
        set({ CargandoCondicionesIVA: false });
      }
    },

    abrirAltaCliente: (nombre = "") => {
      solicitudClienteEditable += 1;
      set({
        ClienteNuevoVisible: true,
        ClienteNuevoNombre: String(nombre ?? "").trim(),
        ClienteEdicionId: 0,
        ClienteEditable: null,
        CargandoClienteEditable: false,
      });
    },

    abrirEdicionCliente: async (cliente = get().Cliente) => {
      const ClienteId = Number(cliente?.Id) || 0;
      const EmpresaId = useStoreHome.getState().EmpresaId;
      if (!ClienteId || !EmpresaId) {
        MensajeError("Seleccione un cliente valido para editar.");
        return false;
      }

      const miSolicitud = ++solicitudClienteEditable;
      set({
        ClienteNuevoVisible: true,
        ClienteNuevoNombre: "",
        ClienteEdicionId: ClienteId,
        ClienteEditable: null,
        CargandoClienteEditable: true,
      });
      const respuesta = await obtenerCliente({ EmpresaId, ClienteId });
      if (
        miSolicitud !== solicitudClienteEditable ||
        useStoreHome.getState().EmpresaId !== EmpresaId
      ) return false;
      if (respuesta.error) {
        set({ CargandoClienteEditable: false });
        MensajeError(mensajeSeguro(respuesta.error, "No se pudo obtener el cliente."));
        return false;
      }

      const editable = normalizarClienteEditable(respuesta.data?.Cliente);
      if (editable.Id !== ClienteId) {
        set({ CargandoClienteEditable: false });
        MensajeError("El servidor no devolvio los datos del cliente solicitado.");
        return false;
      }
      set({ ClienteEditable: editable, CargandoClienteEditable: false });
      return true;
    },

    cerrarFormularioCliente: () => {
      if (get().GuardandoCliente) return;
      solicitudClienteEditable += 1;
      set({
        ClienteNuevoVisible: false,
        ClienteNuevoNombre: "",
        ClienteEdicionId: 0,
        ClienteEditable: null,
        CargandoClienteEditable: false,
      });
    },

    crearCliente: async (datos, opcionesValidacion = {}) => {
      const validacion = validarClienteNuevo(
        datos,
        get().TiposDocumento,
        get().CondicionesIVA,
        opcionesValidacion
      );
      if (!validacion.valido || get().GuardandoCliente) return false;
      set({ GuardandoCliente: true });
      try {
        const cliente = normalizarClienteSeleccion(datos);
        const respuesta = await insertarClienteVenta({
          EmpresaId: useStoreHome.getState().EmpresaId,
          cliente,
          OperadorId: getOperadorId(),
          PcId: getPcId(),
        });
        if (respuesta.error) {
          MensajeError(mensajeSeguro(respuesta.error, "No se pudo crear el cliente."));
          return false;
        }
        const creado = normalizarClienteSeleccion(
          respuesta.data?.Cliente || respuesta.data?.Dato || { ...cliente, Id: respuesta.data?.Id }
        );
        if (!creado.Id) {
          MensajeError("El cliente fue procesado, pero el servidor no devolvio un identificador valido.");
          return false;
        }
        const base = useStoreHome.getState().EmpresaId;
        invalidarCacheClientes(base);
        set({
          ClienteNuevoVisible: false,
          ClienteNuevoNombre: "",
          ClienteEdicionId: 0,
          ClienteEditable: null,
        });
        const listaActualizada = await get().getClientes({ forzar: true });
        const clienteActualizado = listaActualizada.find((item) => Number(item.Id) === creado.Id) || creado;
        await get().setCliente(clienteActualizado);
        MensajeToastExito("Cliente creado correctamente.");
        return true;
      } finally {
        set({ GuardandoCliente: false });
      }
    },

    actualizarCliente: async (datos) => {
      const validacion = validarClienteNuevo(datos, get().TiposDocumento, get().CondicionesIVA);
      const ClienteId = Number(datos?.Id) || 0;
      if (!validacion.valido || !ClienteId || get().GuardandoCliente) return false;

      const EmpresaId = useStoreHome.getState().EmpresaId;
      set({ GuardandoCliente: true });
      try {
        const respuesta = await actualizarClienteApi({
          EmpresaId,
          Cliente: datos,
          OperadorId: getOperadorId(),
          PcId: getPcId(),
        });
        if (respuesta.error) {
          MensajeError(mensajeSeguro(respuesta.error, "No se pudo actualizar el cliente."));
          return false;
        }

        const persistido = normalizarClienteEditable(respuesta.data?.Cliente);
        if (persistido.Id !== ClienteId) {
          MensajeError("El cliente fue procesado, pero el servidor no devolvio datos validos.");
          return false;
        }

        const actualizado = normalizarClienteSeleccion(persistido);
        reemplazarClienteEnCache(EmpresaId, actualizado);
        const listaActual = get().ListaClientes;
        const estabaEnLista = listaActual.some((item) => Number(item.Id) === ClienteId);
        set({
          ListaClientes: estabaEnLista
            ? listaActual.map((item) => Number(item.Id) === ClienteId ? actualizado : item)
            : [...listaActual, actualizado],
        });

        const actualizarSeleccion = get().setCliente(actualizado);
        set({
          ClienteNuevoVisible: false,
          ClienteEdicionId: 0,
          ClienteEditable: null,
          CargandoClienteEditable: false,
        });
        await actualizarSeleccion;
        MensajeToastExito("Cliente actualizado correctamente.");
        return true;
      } finally {
        set({ GuardandoCliente: false });
      }
    },

    eliminarCliente: async (cliente) => {
      const ClienteId = Number(cliente?.Id) || 0;
      const EmpresaId = useStoreHome.getState().EmpresaId;
      if (!ClienteId || !EmpresaId || get().EliminandoClienteId) return false;
      if (ClienteId === Number(get().ClienteConsumidorFinalId)) {
        MensajeError("El cliente Consumidor Final no se puede dar de baja desde esta pantalla.");
        return false;
      }

      set({ EliminandoClienteId: ClienteId });
      try {
        const respuesta = await eliminarClienteApi({
          EmpresaId,
          ClienteId,
          OperadorId: getOperadorId(),
          PcId: getPcId(),
        });
        const error = respuesta.error || respuesta.data?.Error || respuesta.data?.error;
        if (error) {
          MensajeError(mensajeSeguro(error, "No se pudo dar de baja el cliente."));
          return false;
        }

        invalidarCacheClientes(EmpresaId);
        const eraSeleccionado = Number(get().Cliente?.Id) === ClienteId;
        await get().getClientes({ forzar: true });
        if (eraSeleccionado) await get().setConsumidorFinal();
        MensajeToastExito("Cliente dado de baja correctamente.");
        return true;
      } finally {
        set({ EliminandoClienteId: 0 });
      }
    },

    // ---------- Producto ----------
    Mercaderia: null,
    ListaMercaderias: [],
    BuscandoMercaderia: false,
    limpiarResultadosMercaderias: () => {
      claveMercaderiasPos = null;
      secuenciaMercaderiasPos += 1;
      set({ ListaMercaderias: [], BuscandoMercaderia: false });
    },
    cargarCatalogoMercaderias: async ({ signal } = {}) => {
      const EmpresaId = useStoreHome.getState().EmpresaId;
      if (!EmpresaId) return [];
      const miSecuencia = ++secuenciaMercaderiasPos;
      claveMercaderiasPos = null;
      set({ BuscandoMercaderia: true });
      try {
        const data = await listarCatalogoMercaderias({ EmpresaId, signal });
        if (data.aborted) return [];
        if (data.error) return { error: data.error };
        const lista = data.data?.Lista || [];
        if (miSecuencia === secuenciaMercaderiasPos) set({ ListaMercaderias: lista });
        return lista;
      } catch (error) {
        return { error: error.message };
      } finally {
        if (miSecuencia === secuenciaMercaderiasPos) set({ BuscandoMercaderia: false });
      }
    },
    getMercaderia: async (filtros = {}) => {
      const empresaId = useStoreHome.getState().EmpresaId;
      if (!empresaId) return [];
      const evaluacion = evaluarFiltrosMercaderia(filtros);
      if (!evaluacion.valido) { get().limpiarResultadosMercaderias(); return []; }
      if (claveMercaderiasPos === evaluacion.clave) return get().ListaMercaderias;
      const miSecuencia = ++secuenciaMercaderiasPos;
      claveMercaderiasPos = evaluacion.clave;
      const sParametros = crearRequestMercaderiasPiSeun(empresaId, 0, evaluacion.filtros);
      set({ BuscandoMercaderia: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("Combos/MercaderiasPiSeun", sParametros, { signal: filtros.signal });
        if (data.aborted) return [];
        if (data.error) {
          if (miSecuencia === secuenciaMercaderiasPos) claveMercaderiasPos = null;
          return { error: data.error };
        }
        const lista = data.data?.Lista || [];
        if (miSecuencia === secuenciaMercaderiasPos) set({ ListaMercaderias: lista });
        return lista;
      } catch (error) {
        if (miSecuencia === secuenciaMercaderiasPos) claveMercaderiasPos = null;
        return { error: error.message };
      } finally {
        if (miSecuencia === secuenciaMercaderiasPos) set({ BuscandoMercaderia: false });
      }
    },

    ListaUnidades: [],
    BuscandoUnidades: false,
    getUnidades: async () => {
      if (!useStoreHome.getState().EmpresaId || get().BuscandoUnidades) return;
      const sParametros = { EmpresaId: useStoreHome.getState().EmpresaId };
      set({ BuscandoUnidades: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("Combos/Unidades", sParametros);
        if (data.error) {
          MensajeError(data.error);
        } else {
          set({ ListaUnidades: data.data?.Lista || [] });
        }
      } catch (error) {
        MensajeError(error.message);
      } finally {
        set({ BuscandoUnidades: false });
      }
    },

    ListaCategoriasFiscales: [],
    CategoriaFiscalProductoNuevo: null,
    CargandoCategoriasFiscales: false,
    ErrorCategoriasFiscales: "",
    getCategoriasFiscales: async () => {
      if (!useStoreHome.getState().EmpresaId || get().CargandoCategoriasFiscales) return [];
      set({ CargandoCategoriasFiscales: true, ErrorCategoriasFiscales: "" });
      try {
        const respuesta = await listarCategoriasFiscales({
          EmpresaId: useStoreHome.getState().EmpresaId,
        });
        if (respuesta.error) {
          set({ ErrorCategoriasFiscales: respuesta.error });
          return [];
        }
        const lista = respuesta.data?.Lista || [];
        const seleccionActual = get().CategoriaFiscalProductoNuevo;
        const seleccion = lista.find((item) => Number(item.Id) === Number(seleccionActual?.Id)) ||
          lista.find((item) => item.Predeterminada) ||
          null;
        set({ ListaCategoriasFiscales: lista, CategoriaFiscalProductoNuevo: seleccion });
        return lista;
      } catch (error) {
        set({ ErrorCategoriasFiscales: error.message || "No se pudieron cargar las categorías fiscales." });
        return [];
      } finally {
        set({ CargandoCategoriasFiscales: false });
      }
    },

    // ---------- Cantidad / Peso ----------
    Cantidad: 0,

    // ---------- Cobro ----------
    ...defaultVentaState,

    ListaFormasPago: [],
    BuscandoFormasPago: false,
    ErrorFormasPago: "",
    getFormasPago: async () => {
      const EmpresaId = useStoreHome.getState().EmpresaId;
      if (!EmpresaId || get().BuscandoFormasPago) return [];
      set({ BuscandoFormasPago: true, ErrorFormasPago: "" });
      try {
        const data = await _Componentes_WebApiCalls_Post("Combos/FormasPago", { EmpresaId });
        if (data.error) {
          set({ ErrorFormasPago: data.error });
          MensajeError(data.error);
          return [];
        }
        const lista = (data.data?.Lista || [])
          .map(normalizarFormaPago)
          .filter((formaPago) => formaPago.Id > 0 && formaPago.sDescripcion);
        const listaPermitida = filtrarFormasPagoConsumidorFinal(
          lista,
          get().ModoCliente === "consumidorFinal"
        );
        const seleccionActual = listaPermitida.find((formaPago) => formaPago.Id === Number(get().FormaPagoId));
        const seleccion = seleccionActual || obtenerFormaPagoInicial(listaPermitida);
        const formaFiscalPrincipalId = listaPermitida.some(
          (formaPago) => formaPago.Id === Number(get().FormaFiscalPrincipalId)
        ) ? get().FormaFiscalPrincipalId : 0;
        const pagosActuales = get().Pagos || [];
        const pagos = pagosActuales.map((pago) => {
          const forma = listaPermitida.find((item) => item.Id === Number(pago.FormaPagoId));
          if (forma) return { ...pago, FormaPago: forma.sDescripcion };
          if (pago.FormaPagoId) return { ...pago, FormaPagoId: 0, FormaPago: "" };
          if (!pago.FormaPagoId && !pago.Personalizado && seleccion) {
            return { ...pago, FormaPagoId: seleccion.Id, FormaPago: seleccion.sDescripcion };
          }
          return pago;
        });
        set({
          ListaFormasPago: lista,
          FormaPagoId: seleccion?.Id || 0,
          FormaPago: seleccion?.sDescripcion || "",
          FormaFiscalPrincipalId: formaFiscalPrincipalId,
          Pagos: pagos,
        });
        return lista;
      } catch (error) {
        set({ ErrorFormasPago: error.message });
        MensajeError(error.message);
        return [];
      } finally {
        set({ BuscandoFormasPago: false });
      }
    },
    setFormaPago: (FormaPagoId) => {
      const seleccion = obtenerFormasPagoPermitidas(get()).find(
        (formaPago) => formaPago.Id === Number(FormaPagoId)
      );
      set({
        FormaPagoId: seleccion?.Id || 0,
        FormaPago: seleccion?.sDescripcion || "",
      });
    },
    setMontoRecibido: (MontoRecibido) => set({ MontoRecibido }),
    prepararCobro: (total) => {
      const st = get();
      const catalogo = obtenerFormasPagoPermitidas(st);
      const pagos = st.Pagos?.length
        ? sincronizarPagosConTotal(st.Pagos, total)
        : [crearPagoInicial(total, catalogo)];
      const resumenPago = resumirPagos(pagos);
      set({
        Pagos: pagos,
        FormaPagoId: pagos.length === 1 ? pagos[0].FormaPagoId : 0,
        FormaPago: resumenPago.FormaPago,
        MontoRecibido: resumenPago.MontoRecibido,
        FormaFiscalPrincipalId: pagos.length === 1 ? pagos[0].FormaPagoId : st.FormaFiscalPrincipalId,
      });
    },
    sincronizarTotalPagos: (total) => {
      const pagos = sincronizarPagosConTotal(get().Pagos || [], total);
      if (pagos !== get().Pagos) set({ Pagos: pagos });
    },
    agregarPago: (total) => set((st) => ({
      Pagos: agregarPago(st.Pagos, total, obtenerFormasPagoPermitidas(st)),
      FormaPagoId: 0,
      FormaPago: "Pago combinado",
      FormaFiscalPrincipalId: 0,
    })),
    eliminarPago: (clave) => set((st) => {
      const pagos = eliminarPago(st.Pagos, clave);
      const resumenPago = resumirPagos(pagos);
      return {
        Pagos: pagos,
        FormaPago: resumenPago.FormaPago,
        FormaPagoId: pagos.length === 1 ? pagos[0].FormaPagoId : 0,
        FormaFiscalPrincipalId: pagos.length === 1 ? pagos[0].FormaPagoId : st.FormaFiscalPrincipalId,
      };
    }),
    actualizarPago: (clave, campo, valor) => set((st) => {
      const pagos = actualizarPago(st.Pagos, clave, campo, valor, obtenerFormasPagoPermitidas(st));
      const resumenPago = resumirPagos(pagos);
      return {
        Pagos: pagos,
        FormaPago: resumenPago.FormaPago,
        FormaPagoId: pagos.length === 1 ? pagos[0].FormaPagoId : 0,
        MontoRecibido: resumenPago.MontoRecibido,
        FormaFiscalPrincipalId: pagos.length === 1 ? pagos[0].FormaPagoId : st.FormaFiscalPrincipalId,
      };
    }),
    setFormaFiscalPrincipal: (FormaFiscalPrincipalId) => set((st) => ({
      FormaFiscalPrincipalId: obtenerFormasPagoPermitidas(st).some(
        (formaPago) => formaPago.Id === Number(FormaFiscalPrincipalId)
      ) ? Number(FormaFiscalPrincipalId) : 0,
    })),
    setObservacion: (Observacion) => set({ Observacion }),

    // ---------- Precio ----------
    PrecioUnitario: 0,
    BuscandoPrecio: false,
    ErrorPrecio: "",
    IvaMercaderia: null,
    getPrecio: async () => {
      const st = get();
      if (!st.Mercaderia || !st.Mercaderia.Id) return;
      if (!useStoreHome.getState().EmpresaId) return;

      const clienteId = obtenerClientePrecioId(st);
      const mercaderiaId = st.Mercaderia.Id;

      set({ BuscandoPrecio: true, PrecioUnitario: 0, ErrorPrecio: "", IvaMercaderia: null });
      try {
        const sParametros = {
          EmpresaId: useStoreHome.getState().EmpresaId,
          ClienteId: clienteId,
          MercaderiaId: mercaderiaId,
        };
        const [data, respuestaIva] = await Promise.all([
          obtenerPrecioVenta(sParametros),
          consultarIvaMercaderia(sParametros.EmpresaId, mercaderiaId),
        ]);
        const estadoActual = get();
        if (
          estadoActual.Mercaderia?.Id !== mercaderiaId ||
          obtenerClientePrecioId(estadoActual) !== clienteId
        ) {
          return;
        }

        if (data.error) {
          const mensaje = `No existe un precio vigente para el producto seleccionado. ${data.error}`.trim();
          MensajeError(mensaje);
          set({ PrecioUnitario: 0, ErrorPrecio: mensaje });
        } else {
          const precio = obtenerPrecio(data?.data);
          const ivaConfigurado = respuestaIva.data?.Configurado === true;
          const ivaPendiente = respuestaIva.data?.IvaPendiente === true;
          const porcentajeIva = Number(respuestaIva.data?.PorcentajeIVA);
          const iva = respuestaIva.error
            ? {
                valido: false,
                error: respuestaIva.data?.Error || respuestaIva.error,
              }
            : ivaPendiente
              ? {
                  valido: true,
                  conocido: true,
                  pendiente: true,
                  ConSinIVA: false,
                  PorcentajeIVA: 0,
                }
            : ivaConfigurado && Number.isFinite(porcentajeIva)
              ? {
                  valido: true,
                  conocido: true,
                  ConSinIVA: porcentajeIva > 0,
                  PorcentajeIVA: porcentajeIva,
                }
              : {
                  valido: false,
                  conocido: false,
                  ConSinIVA: false,
                  PorcentajeIVA: 0,
                  error: respuestaIva.data?.Error || "La mercaderia no tiene IVA configurado.",
                };
          if (precio === null) {
            const mensaje = "No existe un precio vigente para el producto seleccionado.";
            MensajeError(mensaje);
            set({ PrecioUnitario: 0, ErrorPrecio: mensaje });
          } else if (!iva.valido) {
            MensajeError(iva.error);
            set({ PrecioUnitario: precio, IvaMercaderia: iva, ErrorPrecio: iva.error });
          } else {
            set({ PrecioUnitario: precio, IvaMercaderia: iva, ErrorPrecio: "" });
          }
        }
      } catch (error) {
        MensajeError(error.message);
        set({ PrecioUnitario: 0, ErrorPrecio: error.message });
      } finally {
        const estadoFinal = get();
        if (
          estadoFinal.Mercaderia?.Id === mercaderiaId &&
          obtenerClientePrecioId(estadoFinal) === clienteId
        ) {
          set({ BuscandoPrecio: false });
        }
      }
    },

    // ---------- Bonificacion/descuento ----------
    DescuentoLinea: 0,

    // ---------- Producto nuevo desde la venta ----------
    ArticuloLibreVisible: false,
    ArticuloLibreDescripcion: "",
    ArticuloLibreUnidad: null,
    ArticuloLibreCantidad: 1,
    ArticuloLibrePrecioUnitario: 0,
    ArticuloLibreDescuentoLinea: 0,
    ArticuloLibreCrearCatalogo: true,
    ArticuloLibreConSinIVA: false,
    ArticuloLibrePorcentajeIVA: 0,

    setArticuloLibreVisible: (ArticuloLibreVisible) => set({ ArticuloLibreVisible }),
    setArticuloLibreCampo: (campo, valor) => set({ [campo]: valor }),
    limpiarArticuloLibre: () => {
      set({
        ArticuloLibreDescripcion: "",
        ArticuloLibreUnidad: null,
        ArticuloLibreCantidad: 1,
        ArticuloLibrePrecioUnitario: 0,
        ArticuloLibreDescuentoLinea: 0,
        ArticuloLibreCrearCatalogo: true,
        ArticuloLibreConSinIVA: false,
        ArticuloLibrePorcentajeIVA: 0,
        CategoriaFiscalProductoNuevo:
          get().ListaCategoriasFiscales.find((item) => item.Predeterminada) || null,
      });
    },

    // ---------- Ticket actual ----------
    TicketLineas: [],
    ErroresLineas: {},
    UltimaVenta: null,
    VentasRecientes: [],
    CargandoVentasRecientes: false,
    ErrorVentasRecientes: "",
    ClaveVentasRecientes: "",
    cargarVentasRecientes: async ({ CajaSesionId = 0, Cantidad = 10, forzar = false } = {}) => {
      const EmpresaId = Number(useStoreHome.getState().EmpresaId) || 0;
      const cajaSesionId = Number(CajaSesionId) || 0;
      const cantidad = Math.min(50, Math.max(1, Number(Cantidad) || 10));
      const clave = `${EmpresaId}:${cajaSesionId}:${cantidad}`;
      if (!EmpresaId) return false;
      if (!forzar && get().ClaveVentasRecientes === clave && !get().ErrorVentasRecientes) return true;

      abortVentasRecientes?.abort();
      abortVentasRecientes = new AbortController();
      const miSolicitud = ++solicitudVentasRecientes;
      set({ CargandoVentasRecientes: true, ErrorVentasRecientes: "" });
      const respuesta = await obtenerUltimasVentas({
        EmpresaId,
        CajaSesionId: cajaSesionId,
        Cantidad: cantidad,
      }, { signal: abortVentasRecientes.signal });
      if (miSolicitud !== solicitudVentasRecientes || respuesta.aborted) return false;

      const error = respuesta.error || respuesta.data?.Error || respuesta.data?.error || "";
      set({
        CargandoVentasRecientes: false,
        ErrorVentasRecientes: error,
        ClaveVentasRecientes: error ? "" : clave,
        ...(error ? {} : { VentasRecientes: extraerUltimasVentas(respuesta.data) }),
      });
      return !error;
    },
    PagosPorVenta: {},
    cargarPagosVenta: async (ventaId) => {
      const id = Number(ventaId) || 0;
      if (!id) return false;
      const existente = get().PagosPorVenta[id];
      if (existente?.cargando || existente?.cargado) return !existente?.error;
      set((st) => ({ PagosPorVenta: {
        ...st.PagosPorVenta,
        [id]: { cargando: true, cargado: false, error: "", lista: [] },
      } }));
      const respuesta = await obtenerPagosVenta({
        EmpresaId: useStoreHome.getState().EmpresaId,
        VentaId: id,
      });
      const error = respuesta.error || respuesta.data?.Error || "";
      const lista = Array.isArray(respuesta.data?.Lista) ? respuesta.data.Lista : [];
      set((st) => ({ PagosPorVenta: {
        ...st.PagosPorVenta,
        [id]: {
          cargando: false,
          cargado: !error,
          error,
          lista,
          total: Number(respuesta.data?.Total) || 0,
        },
      } }));
      if (error) MensajeError(error);
      return !error;
    },
    ResultadoVenta: ventaPendienteInicial?.resultado || null,
    VentaPendiente: ventaPendienteInicial,
    ClaveIdempotencia: ventaPendienteInicial?.clave || "",
    EstadoEnvioVenta: "inactivo",
    EstadoComercialVenta: "sin-confirmar",
    EstadoFacturaLocal: "sin-factura",
    EstadoArca: "",
    ErrorFiscal: "",
    PoliticaFacturacion: POLITICAS_FACTURACION.INMEDIATA,
    DescargandoComprobante: false,
    ImprimiendoComprobante: false,
    PendientesArca: [],
    CargandoPendientesArca: false,
    FacturasReintentando: [],
    CatalogoLineaVisible: false,
    CatalogoLinea: null,
    CatalogandoLinea: false,

    nuevaVenta: () => {
      limpiarVentaPendiente();
      get().limpiarTicket();
      set({
        ResultadoVenta: null,
        VentaPendiente: null,
        ClaveIdempotencia: "",
        EstadoEnvioVenta: "inactivo",
        EstadoComercialVenta: "sin-confirmar",
        EstadoFacturaLocal: "sin-factura",
        EstadoArca: "",
        ErrorFiscal: "",
      });
    },

    recuperarVentaPendiente: async () => {
      const pendiente = obtenerVentaPendiente();
      if (!pendiente) return null;
      const EmpresaId = useStoreHome.getState().EmpresaId;
      if (!perteneceAlContextoActual(pendiente, EmpresaId)) {
        limpiarVentaPendiente();
        set({
          VentaPendiente: null,
          ClaveIdempotencia: "",
          ResultadoVenta: null,
          EstadoEnvioVenta: "inactivo",
          EstadoComercialVenta: "sin-confirmar",
          EstadoFacturaLocal: "sin-factura",
          EstadoArca: "",
          ErrorFiscal: "",
        });
        return null;
      }

      const resultadoGuardado = pendiente.resultado || null;
      const ventaGuardada = resultadoGuardado?.venta || null;
      set({
        VentaPendiente: pendiente,
        ClaveIdempotencia: pendiente.clave,
        ResultadoVenta: resultadoGuardado,
        ...(ventaGuardada
          ? {
              UltimaVenta: ventaGuardada,
              VentasRecientes: agregarVentaReciente(get().VentasRecientes, ventaGuardada),
            }
          : {}),
        EstadoEnvioVenta: resultadoGuardado ? "confirmada" : "inactivo",
        EstadoComercialVenta: resultadoGuardado?.estadoVenta || "sin-confirmar",
        EstadoFacturaLocal: resultadoGuardado ? estadoFacturaLocalDesdeResultado(resultadoGuardado) : "sin-factura",
        EstadoArca: resultadoGuardado?.estadoFactura || "",
        ErrorFiscal: resultadoGuardado?.ultimoError || resultadoGuardado?.error || "",
      });
      const ventaId = Number(resultadoGuardado?.ventaId) || 0;
      if (!ventaId || !requiereReconciliarDocumentos(resultadoGuardado)) return pendiente;
      const respuesta = await obtenerDocumentoVenta({
        EmpresaId,
        VentaId: ventaId,
      });
      if (respuesta.error) return pendiente;
      const documento = normalizarDocumentoVenta(respuesta.data);
      const resultado = { ...pendiente.resultado, ...documento };
      const actualizado = guardarResultadoPendiente(pendiente, resultado);
      set({
        VentaPendiente: actualizado,
        ResultadoVenta: resultado,
        EstadoComercialVenta: documento.estadoVenta,
        EstadoFacturaLocal: estadoFacturaLocalDesdeResultado(documento),
        ErrorFiscal: documento.ultimoError,
      });
      return actualizado;
    },

    abrirCatalogarLinea: ({ linea, detalleId, indice }) => {
      set({
        CatalogoLineaVisible: true,
        CatalogoLinea: crearCatalogoLineaDesdeVenta(linea, detalleId, indice),
      });
    },

    cerrarCatalogarLinea: () => {
      set({ CatalogoLineaVisible: false, CatalogoLinea: null, CatalogandoLinea: false });
    },

    setCatalogoLineaCampo: (campo, valor) => {
      set({
        CatalogoLinea: {
          ...(get().CatalogoLinea || {}),
          [campo]: valor,
        },
      });
    },

    catalogarLinea: async () => {
      const st = get();
      const catalogo = st.CatalogoLinea;
      if (!catalogo || !catalogo.DetalleId) {
        MensajeError("No se encontro la linea a catalogar.");
        return false;
      }
      if (st.CatalogandoLinea) return false;

      const descripcion = String(catalogo.Descripcion || "").trim();
      const unidadDescripcion = String(catalogo.Unidad?.sDescripcion || "").trim();
      const mercaderiaTipoId = Number(catalogo.MercaderiaTipoId) || 0;

      if (!descripcion) {
        MensajeError("Debe ingresar la descripcion del producto.");
        return false;
      }
      if (!unidadDescripcion) {
        MensajeError("Debe ingresar la unidad del producto.");
        return false;
      }
      if (mercaderiaTipoId <= 0) {
        MensajeError("Debe seleccionar el tipo de mercaderia.");
        return false;
      }

      set({ CatalogandoLinea: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("Api00557/CatalogarDetalle", {
          EmpresaId: useStoreHome.getState().EmpresaId,
          VentaDetalleId: Number(catalogo.DetalleId) || 0,
          Unidad: {
            Id: Number(catalogo.Unidad?.Id) || 0,
            sCodigo: unidadDescripcion,
            sDescripcion: unidadDescripcion,
          },
          MercaderiaTipoId: mercaderiaTipoId,
          LlevaStock: !!catalogo.LlevaStock,
          CantidadEstandar: Math.max(1, Number(catalogo.CantidadEstandar) || 1),
          PesoEstandar: Number(catalogo.PesoEstandar) || 0,
          VencimientoCantidad: Number(catalogo.VencimientoCantidad) || 0,
          VencimientoPorDia: !!catalogo.VencimientoPorDia,
          OperadorId: getOperadorId(),
          PcId: getPcId(),
        });

        if (data.error) {
          MensajeError(data.error);
          return false;
        }

        const nuevoMercaderiaId = Number(data.data?.dato ?? data.data?.Dato ?? 0) || 0;
        const actualizarVenta = (venta) => {
          if (!venta || !Array.isArray(venta.lstDetalle) || !Array.isArray(venta.DetalleIds)) return venta;
          const indiceLinea = venta.DetalleIds.findIndex((id) => Number(id) === Number(catalogo.DetalleId));
          if (indiceLinea < 0) return venta;
          return {
            ...venta,
            lstDetalle: venta.lstDetalle.map((linea, idx) =>
              idx === indiceLinea
                ? { ...linea, Mercaderia_Id: nuevoMercaderiaId, bCatalogado: true, CrearCatalogo: false }
                : linea
            ),
          };
        };
        set({
          UltimaVenta: actualizarVenta(get().UltimaVenta),
          VentasRecientes: get().VentasRecientes.map(actualizarVenta),
        });

        MensajeToastExito("Producto catalogado correctamente.");
        set({ CatalogoLineaVisible: false, CatalogoLinea: null });
        return true;
      } catch (error) {
        MensajeError(error.message);
        return false;
      } finally {
        set({ CatalogandoLinea: false });
      }
    },

    agregarLinea: () => {
      const st = get();
      if (!st.Mercaderia || !st.Mercaderia.Id) {
        MensajeInfo("Debe seleccionar un producto.");
        return;
      }
      if (Number(st.Cantidad) <= 0) {
        MensajeInfo("La cantidad debe ser mayor a 0.");
        return;
      }
      const precioUnit = Number(st.PrecioUnitario) || 0;
      if (precioUnit <= 0) {
        MensajeInfo("El precio unitario debe ser mayor que cero.");
        return;
      }
      if (st.ErrorPrecio || !st.IvaMercaderia?.valido) {
        MensajeInfo(st.ErrorPrecio || "No se pudo obtener el IVA real de la mercaderia.");
        return;
      }

      // El stock avisa, pero no bloquea: la linea queda marcada como "Sin stock".
      const stockDisponible = Number(st.Mercaderia?.sExtra ?? 0);
      const cantidadNueva = Number(st.Cantidad);
      const cantidadActualEnTicket = st.TicketLineas
        .filter((l) => l.Mercaderia?.Id === st.Mercaderia.Id)
        .reduce((acc, l) => acc + (Number(l.Cantidad) || 0), 0);
      const cantidadTotalSolicitada = cantidadActualEnTicket + cantidadNueva;
      const ventaSinStock = stockDisponible <= 0 || cantidadTotalSolicitada > stockDisponible;

      // Si ya existe la misma mercaderia y precio, acumulamos cantidad y descuento monetario.
      const descuento = Number(st.DescuentoLinea) || 0;
      const cantidad = cantidadNueva;
      const subtotalBruto = redondearMoneda(precioUnit * cantidad);
      if (descuento < 0 || descuento > subtotalBruto) {
        MensajeInfo("El descuento debe ser un importe entre cero y el bruto de la linea.");
        return;
      }
      const baseLinea = {
        Cantidad: cantidad,
        PrecioUnitario: precioUnit,
        DescuentoLinea: descuento,
        ConSinIVA: st.IvaMercaderia.ConSinIVA,
        PorcentajeIVA: st.IvaMercaderia.PorcentajeIVA,
        IVAConocido: st.IvaMercaderia.conocido !== false,
      };
      const subtotal = calcularVentaLinea(baseLinea).subtotal;

      const indiceLineaExistente = st.TicketLineas.findIndex(
        (l) =>
          l.Mercaderia?.Id === st.Mercaderia.Id &&
          Number(l.PrecioUnitario || 0) === precioUnit
      );

      let ticketLineas = [...st.TicketLineas];
      if (indiceLineaExistente >= 0) {
        const lineaActual = ticketLineas[indiceLineaExistente];
        const cantidadTotal = (Number(lineaActual.Cantidad) || 0) + cantidad;
        const descuentoTotalLinea = redondearMoneda((Number(lineaActual.DescuentoLinea) || 0) + descuento);
        const subtotalTotal = calcularVentaLinea({ ...baseLinea, Cantidad: cantidadTotal, DescuentoLinea: descuentoTotalLinea }).subtotal;

        ticketLineas[indiceLineaExistente] = {
          ...lineaActual,
          TipoLinea: "Producto",
          Cantidad: cantidadTotal,
          PrecioUnitario: precioUnit,
          DescuentoLinea: descuentoTotalLinea,
          Subtotal: subtotalTotal,
          VentaSinStock: ventaSinStock,
          PrecioClienteId: obtenerClienteFacturacionId(st),
          PrecioVigente: true,
          ErrorPrecio: "",
          ConSinIVA: st.IvaMercaderia.ConSinIVA,
          PorcentajeIVA: st.IvaMercaderia.PorcentajeIVA,
          IVAConocido: st.IvaMercaderia.conocido !== false,
          IvaPendiente: st.IvaMercaderia.pendiente === true,
        };
      } else {
        ticketLineas = [
          ...ticketLineas,
          {
            Id: Date.now(),
            TipoLinea: "Producto",
            Mercaderia: st.Mercaderia,
            Cantidad: cantidad,
            PrecioUnitario: precioUnit,
            DescuentoLinea: descuento,
            Subtotal: subtotal,
            VentaSinStock: ventaSinStock,
            PrecioClienteId: obtenerClienteFacturacionId(st),
            PrecioVigente: true,
            ErrorPrecio: "",
            ConSinIVA: st.IvaMercaderia.ConSinIVA,
            PorcentajeIVA: st.IvaMercaderia.PorcentajeIVA,
            IVAConocido: st.IvaMercaderia.conocido !== false,
            IvaPendiente: st.IvaMercaderia.pendiente === true,
          },
        ];
      }

      set({
        TicketLineas: estimarStockTicket(ticketLineas),
        Mercaderia: null,
        Cantidad: 0,
        PrecioUnitario: 0,
        DescuentoLinea: 0,
        ErrorPrecio: "",
        IvaMercaderia: null,
      });
      void get().cargarOpcionesFacturacion();

      if (ventaSinStock) {
        MensajeToastAdvertencia("Producto agregado sin stock suficiente.", 3000);
      }
    },

    agregarArticuloLibre: () => {
      const st = get();
      const descripcion = String(st.ArticuloLibreDescripcion || "").trim();
      const unidad = st.ArticuloLibreUnidad;
      const cantidad = Number(st.ArticuloLibreCantidad) || 0;
      const precioUnit = Number(st.ArticuloLibrePrecioUnitario) || 0;
      const descuento = Number(st.ArticuloLibreDescuentoLinea) || 0;
      const categoriaFiscal = st.CategoriaFiscalProductoNuevo;

      if (!descripcion) {
        MensajeInfo("Debe ingresar una descripcion para el producto nuevo.");
        return false;
      }
      if (!unidad || typeof unidad !== "object" || Number(unidad.Id) <= 0) {
        MensajeInfo("Debe seleccionar una unidad de medida para el producto nuevo.");
        return false;
      }
      if (!esCategoriaFiscalValida(categoriaFiscal)) {
        MensajeInfo("Debe seleccionar la categoría fiscal del producto nuevo.");
        return false;
      }
      if (cantidad <= 0) {
        MensajeInfo("La cantidad debe ser mayor a 0.");
        return false;
      }
      if (precioUnit <= 0) {
        MensajeInfo("El precio final del producto nuevo debe ser mayor que cero.");
        return false;
      }
      const subtotalBruto = redondearMoneda(precioUnit * cantidad);
      if (descuento < 0 || descuento > subtotalBruto) {
        MensajeInfo("El descuento debe ser un importe entre cero y el bruto de la linea.");
        return false;
      }
      const precioNeto = calcularNetoDesdePrecioFinal(precioUnit, categoriaFiscal);
      const descuentoNeto = calcularNetoDesdePrecioFinal(descuento, categoriaFiscal);
      const subtotal = calcularVentaLinea({
        Cantidad: cantidad,
        PrecioUnitario: precioNeto,
        DescuentoLinea: descuentoNeto,
        ConSinIVA: categoriaFiscal.ConSinIVA,
        PorcentajeIVA: categoriaFiscal.PorcentajeIVA,
      }).subtotal;

      set({
        TicketLineas: estimarStockTicket([
          ...st.TicketLineas,
          {
            Id: `nuevo-${Date.now()}`,
            TipoLinea: "Producto",
            ProductoNuevo: true,
            IvaPendiente: false,
            Mercaderia: null,
            Unidad: unidad,
            CategoriaFiscal: categoriaFiscal,
            CategoriaFiscalId: categoriaFiscal.Id,
            CategoriaFiscalVersion: categoriaFiscal.Version,
            DescripcionManual: descripcion,
            Cantidad: cantidad,
            PrecioUnitario: precioNeto,
            PrecioFinalUnitario: precioUnit,
            DescuentoLinea: descuentoNeto,
            DescuentoFinalLinea: descuento,
            Subtotal: subtotal,
            VentaSinStock: true,
            PrecioVigente: true,
            CrearCatalogo: true,
            ConSinIVA: categoriaFiscal.ConSinIVA,
            PorcentajeIVA: categoriaFiscal.PorcentajeIVA,
            IVAConocido: true,
          },
        ]),
        ArticuloLibreDescripcion: "",
        ArticuloLibreUnidad: null,
        ArticuloLibreCantidad: 1,
        ArticuloLibrePrecioUnitario: 0,
        ArticuloLibreDescuentoLinea: 0,
        ArticuloLibreCrearCatalogo: true,
        ArticuloLibreConSinIVA: false,
        ArticuloLibrePorcentajeIVA: 0,
        CategoriaFiscalProductoNuevo:
          st.ListaCategoriasFiscales.find((item) => item.Predeterminada) || null,
        ArticuloLibreVisible: false,
      });
      void get().cargarOpcionesFacturacion();
      return true;
    },

    actualizarLinea: (id, cambios) => {
      const st = get();
      const ticketLineas = st.TicketLineas.map((linea) => {
        if (linea.Id !== id) return linea;

        const cantidad = cambios.Cantidad !== undefined ? Number(cambios.Cantidad) || 0 : Number(linea.Cantidad) || 0;
        const precioUnitario =
          cambios.PrecioUnitario !== undefined ? Number(cambios.PrecioUnitario) || 0 : Number(linea.PrecioUnitario) || 0;
        const descuentoLinea =
          cambios.DescuentoLinea !== undefined ? Number(cambios.DescuentoLinea) || 0 : Number(linea.DescuentoLinea) || 0;
        const subtotal = calcularVentaLinea({ ...linea, ...cambios, Cantidad: cantidad, PrecioUnitario: precioUnitario, DescuentoLinea: descuentoLinea }).subtotal;

        return {
          ...linea,
          ...cambios,
          Cantidad: cantidad,
          PrecioUnitario: precioUnitario,
          DescuentoLinea: descuentoLinea,
          Subtotal: subtotal,
        };
      });

      const lineasEstimadas = estimarStockTicket(ticketLineas);
      const validacion = validarVenta(lineasEstimadas);
      set({ TicketLineas: lineasEstimadas, ErroresLineas: validacion.erroresLineas });
      void get().cargarOpcionesFacturacion();
    },

    eliminarLinea: (id) => {
      set({
        TicketLineas: estimarStockTicket(get().TicketLineas.filter((l) => l.Id !== id)),
        ErroresLineas: {},
      });
      void get().cargarOpcionesFacturacion();
    },

    limpiarTicket: async () => {
      // Reiniciamos el ticket y dejamos la caja lista para la siguiente venta.
      const formaPagoInicial = obtenerFormaPagoInicial(
        filtrarFormasPagoConsumidorFinal(get().ListaFormasPago, true)
      );
      set({
        TicketLineas: [],
        Cliente: null,
        ModoCliente: "consumidorFinal",
        SolicitaIdentificacionFiscal: false,
        Mercaderia: null,
        Cantidad: 0,
        PrecioUnitario: 0,
        DescuentoLinea: 0,
        ArticuloLibreVisible: false,
        ArticuloLibreDescripcion: "",
        ArticuloLibreUnidad: null,
        ArticuloLibreCantidad: 1,
        ArticuloLibrePrecioUnitario: 0,
        ArticuloLibreDescuentoLinea: 0,
        ArticuloLibreCrearCatalogo: true,
        ArticuloLibreConSinIVA: false,
        ArticuloLibrePorcentajeIVA: 0,
        ErrorPrecio: "",
        IvaMercaderia: null,
        ErroresLineas: {},
        OpcionesFacturacion: [],
        NumeradorId: 0,
        CargandoOpcionesFacturacion: false,
        ErrorOpcionesFacturacion: "",
        CondicionIVASeleccionada: "",
        MontoConsumidorFinalSinIdentificar: 0,
        RequiereIdentificacionFiscal: false,
        EsConsumidorFinalGenerico: false,
        ClienteSeleccionRequerida: false,
        EvaluacionFiscalClave: "",
        FacturarComoConsumidorFinal: false,
        ...defaultVentaState,
        FormaPagoId: formaPagoInicial?.Id || 0,
        FormaPago: formaPagoInicial?.sDescripcion || "",
      });
      await get().cargarOpcionesFacturacion();
    },

    // ---------- Confirmar Venta ----------
    ConfirmandoVenta: false,

    confirmarVenta: async () => {
      let st = get();
      if (ventaEnCurso || st.ConfirmandoVenta) return false;
      if (useStoreCajas.getState().cerrando) {
        MensajeError("La caja se esta cerrando. Espere a que finalice el arqueo.");
        return false;
      }
      let sesionCaja = useStoreCajas.getState().sesionActiva;
      if (!sesionAbierta(sesionCaja)) {
        sesionCaja = await useStoreCajas.getState().resolverCaja();
      }
      if (!sesionAbierta(sesionCaja)) {
        useStoreCajas.setState({ aperturaRequerida: false });
        MensajeError("No se pudo preparar el punto de venta. Reintentá en unos segundos.");
        return false;
      }
      if (st.TicketLineas.length === 0) {
        MensajeInfo("No hay productos en el ticket.");
        return false;
      }
      if (st.BuscandoFormasPago || (!(st.Pagos || []).length && !st.FormaPagoId) || st.ErrorFormasPago) {
        MensajeError(st.ErrorFormasPago || "Espere a que se carguen las formas de pago y seleccione una.");
        return false;
      }

      const validacion = validarVenta(st.TicketLineas);
      set({ ErroresLineas: validacion.erroresLineas });
      if (!validacion.valido) {
        MensajeError("Revise los errores indicados en las lineas del ticket.");
        return false;
      }

      const numeradorSeleccionado = st.NumeradorId;
      const opcionesActualizadas = await get().cargarOpcionesFacturacion({
        preservarNumeradorId: numeradorSeleccionado,
      });
      st = get();
      if (!opcionesActualizadas || st.CargandoOpcionesFacturacion || !st.NumeradorId || st.ErrorOpcionesFacturacion) {
        MensajeError(st.ErrorOpcionesFacturacion || "No se pudieron verificar las opciones de facturacion.");
        return false;
      }
      if (st.ModoCliente === "consumidorFinal" && st.RequiereIdentificacionFiscal) {
        const mensaje = st.SolicitaIdentificacionFiscal
          ? "El comprador solicito CUIT en el comprobante. Seleccione o cree un cliente real con CUIT."
          : "Por el importe de la operacion debe seleccionar o crear un cliente identificado.";
        set({ ClienteSeleccionRequerida: true, ErrorFiscal: mensaje });
        MensajeError(mensaje);
        return false;
      }
      if (
        st.ModoCliente === "cliente" &&
        st.SolicitaIdentificacionFiscal &&
        !clienteTieneCuit(st.Cliente, st.TiposDocumento)
      ) {
        const mensaje = "El comprador solicito CUIT en el comprobante. El cliente seleccionado no tiene un CUIT valido.";
        set({ ClienteSeleccionRequerida: true, ErrorFiscal: mensaje });
        MensajeError(mensaje);
        return false;
      }

      const validacionActual = validarVenta(st.TicketLineas);
      if (!validacionActual.valido || crearClaveEvaluacionFiscal(st) !== st.EvaluacionFiscalClave) {
        MensajeError("La venta cambio durante la verificacion fiscal. Revise los datos e intente nuevamente.");
        return false;
      }
      const resumen = validacionActual.resumen;
      let pagos = st.Pagos || [];
      if (pagos.length === 0 && st.FormaPagoId > 0) {
        const pagoLegacy = crearPago({
          formaPago: { Id: st.FormaPagoId, sDescripcion: st.FormaPago },
          importeCentavos: Math.round(resumen.TotalConIva * 100),
        });
        pagos = actualizarPago(
          [pagoLegacy],
          pagoLegacy.ClaveUi,
          "MontoRecibido",
          st.MontoRecibido ? String(st.MontoRecibido) : "",
          st.ListaFormasPago
        );
      }
      const validacionPagos = validarPagos(pagos, resumen.TotalConIva);
      if (!validacionPagos.valido) {
        const mensaje = Object.values(validacionPagos.erroresPorClave).flat()[0];
        MensajeError(mensaje || "Revise las formas de pago.");
        return false;
      }
      const formasCuentaCorriente = st.ListaFormasPago.filter(esCuentaCorriente);
      const usaCuentaCorriente = st.ModoCliente === "consumidorFinal" && (
        pagos.some((pago) => formasCuentaCorriente.some((forma) => forma.Id === Number(pago.FormaPagoId)))
        || formasCuentaCorriente.some((forma) => forma.Id === Number(st.FormaFiscalPrincipalId))
      );
      if (usaCuentaCorriente) {
        MensajeError("Consumidor Final no admite ventas en cuenta corriente. Seleccione una forma de pago inmediata.");
        return false;
      }
      const resumenPago = resumirPagos(pagos);
      const formaFiscalId = pagos.length === 1
        ? pagos[0].FormaPagoId
        : Number(st.FormaFiscalPrincipalId) || 0;
      if (pagos.length > 1 && formaFiscalId <= 0) {
        MensajeError("Seleccione la forma fiscal principal para la factura con pagos combinados.");
        return false;
      }
      if (ventaEnCurso || get().ConfirmandoVenta) return false;
      ventaEnCurso = true;
      set({
        ConfirmandoVenta: true,
        EstadoEnvioVenta: "enviando",
        ErrorFiscal: "",
      });
      try {
        const clienteFacturacionId = obtenerClienteRequestId(st);
        const EmpresaId = useStoreHome.getState().EmpresaId;
        const operadorId = getOperadorId();
        const pcId = getPcId();

        const venta = crearEntradaVenta({
          estado: st,
          clienteId: clienteFacturacionId,
          resumen,
          resumenPago,
          operadorId,
        });

        if (!EmpresaId) {
          MensajeError("No se encontro la conexion a la base de datos.");
          return;
        }

        if (EmpresaId <= 0) {
          MensajeError("No se encontro una empresa activa para registrar la venta.");
          return;
        }

        const detalleLegacy = await construirDetalleLegacy({
          lineas: st.TicketLineas,
          EmpresaId,
        });

        if (detalleLegacy.error) {
          MensajeError(detalleLegacy.error);
          return;
        }

        const oEntrada = venta;
        const oSalida = {
          Resumen: construirResumenLegacy({
            clienteId: clienteFacturacionId,
            observacion: st.Observacion || "",
            operadorId,
          }),
          Detalle: detalleLegacy.detalle,
          EnviarMail: false,
        };

        const requestSinClave = crearRequestVenta({
          EmpresaId,
          cajaSesionId: Number(sesionCaja.id ?? sesionCaja.Id),
          venta: oEntrada,
          salida: oSalida,
          operadorId,
          pcId,
          facturacion: obtenerConfiguracionFacturacion(
            st.NumeradorId,
            formaFiscalId,
            st.SolicitaIdentificacionFiscal,
            st.FacturarComoConsumidorFinal
          ),
        });
        const contenidoComercial = crearContenidoComercialVenta({
          request: requestSinClave,
          politicaFacturacion: st.PoliticaFacturacion,
        });
        const pendiente = resolverIdempotencia({
          contenidoComercial,
          request: requestSinClave,
          cajaId: pcId || EmpresaId,
          uuidFactory: generarUuid,
        });
        const claveIdempotencia = pendiente.clave;
        set({ ClaveIdempotencia: claveIdempotencia, VentaPendiente: pendiente });
        const data = await insertarVenta({
          ...pendiente.request,
          ClaveIdempotencia: claveIdempotencia,
        });

        if (data.error) {
          if (esErrorSesionCaja(data.error)) {
            useStoreCajas.getState().limpiarSesion();
            useStoreCajas.setState({ error: data.error, aperturaRequerida: false });
          }
          const resultadoParcial = data.data ? normalizarResultadoVenta(data.data) : null;
          if (resultadoParcial?.ventaId > 0) {
            const ventaConfirmada = aplicarResultadoStockVenta({
              ...venta,
              VentaId: resultadoParcial.ventaId,
              DetalleIds: resultadoParcial.detalleIds,
            }, resultadoParcial.detalleStock);
            const resultadoCompleto = {
              ...resultadoParcial,
              venta: ventaConfirmada,
              opcionFacturacion: st.OpcionesFacturacion.find((opcion) => opcion.NumeradorId === st.NumeradorId),
              condicionIVA: st.CondicionIVASeleccionada,
            };
            set({
              UltimaVenta: ventaConfirmada,
              VentasRecientes: agregarVentaReciente(get().VentasRecientes, ventaConfirmada),
              ResultadoVenta: resultadoCompleto,
              EstadoEnvioVenta: "confirmada",
              EstadoComercialVenta: resultadoParcial.estadoVenta || ESTADOS_VENTA.ERROR_FACTURA_LOCAL,
              EstadoFacturaLocal: "error",
              ErrorFiscal: mensajeSeguro(
                resultadoParcial.ultimoError || data.error,
                "La venta y el remito fueron generados, pero fallo la factura local."
              ),
            });
            MensajeError(get().ErrorFiscal);
            return true;
          }
          const esErrorConexion = data.esErrorRed || /conect|network|fetch|timeout|aborted/i.test(data.error);
          const errorVenta = mensajeVentaConIvaFaltante(data.error);
          set({
            EstadoEnvioVenta: esErrorConexion ? "incierto" : "error",
            ErrorFiscal: mensajeSeguro(
              errorVenta,
              esErrorConexion
                ? "No pudimos confirmar el resultado. Reintente con el mismo ticket para consultar la operacion sin duplicarla."
                : "No se pudo confirmar la venta. Revise los datos e intente nuevamente."
            ),
          });
          MensajeError(get().ErrorFiscal);
          return false;
        }

        const respuesta = data.data || {};
        const resultado = normalizarResultadoVenta(respuesta);
        if (resultado.ventaId <= 0) {
          set({
            EstadoEnvioVenta: "incierto",
            ErrorFiscal: "La venta fue recibida, pero no pudimos confirmar su numero. No arme otra venta; reintente con este mismo ticket.",
          });
          MensajeError(get().ErrorFiscal);
          return false;
        }

        venta.IdentificadorId = resultado.identificadorId;
        venta.VentaId = resultado.ventaId;
        venta.Codbar = resultado.codbar;
        venta.EtiquetaCaja = resultado.etiquetaCaja;
        venta.EtiquetaCargada = resultado.etiquetaCargada;
        venta.DetalleIds = resultado.detalleIds;
        const ventaConfirmada = aplicarResultadoStockVenta(venta, resultado.detalleStock);
        const resultadoCompleto = {
          ...resultado,
          venta: ventaConfirmada,
          opcionFacturacion: st.OpcionesFacturacion.find((opcion) => opcion.NumeradorId === st.NumeradorId),
          condicionIVA: st.CondicionIVASeleccionada,
        };
        const pendienteActualizado = guardarResultadoPendiente(pendiente, resultadoCompleto);
        const facturaLocalFallida =
          resultado.estadoVenta === ESTADOS_VENTA.ERROR_FACTURA_LOCAL ||
          resultado.estadoFactura === ESTADOS_ARCA.ERROR_LOCAL;
        set({
          UltimaVenta: ventaConfirmada,
          VentasRecientes: agregarVentaReciente(get().VentasRecientes, ventaConfirmada),
          ResultadoVenta: resultadoCompleto,
          VentaPendiente: pendienteActualizado,
          EstadoEnvioVenta: "confirmada",
          EstadoComercialVenta: resultado.estadoVenta || "Confirmada",
          EstadoFacturaLocal: facturaLocalFallida ? "error" : estadoFacturaLocalDesdeResultado(resultado),
          EstadoArca: resultado.estadoFactura,
          ErrorFiscal: mensajeSeguro(resultado.ultimoError || resultado.error, facturaLocalFallida ? "La venta y el remito fueron generados, pero fallo la factura local." : ""),
        });
        const cantidadSinStock = resultado.detalleStock
          .reduce((total, item) => total + (Number(item.cantidadSinStock) || 0), 0);
        if (resultado.ivaPendiente) {
          MensajeToastAdvertencia(
            `Venta ${resultado.ventaId} registrada. Uno de los productos necesita una categoría fiscal para emitir la factura.`,
            6000
          );
        } else if (cantidadSinStock > 0) {
          MensajeToastAdvertencia(
            `Venta ${resultado.ventaId} registrada. ${cantidadSinStock.toLocaleString("es-AR")} unidades quedaron sin stock.`,
            5000
          );
        } else {
          MensajeToastExito(`Venta ${resultado.ventaId} registrada correctamente.`);
        }
        await get().limpiarTicket();
        get().limpiarResultadosMercaderias();
        if (
          resultado.facturaId > 0 &&
          resultado.emitirElectronica &&
          esEstadoEmitible(resultado.estadoFactura)
        ) {
          await get().emitirArca(resultado.facturaId);
        }
        return true;
      } finally {
        ventaEnCurso = false;
        set({ ConfirmandoVenta: false });
      }
    },

    cargarComprobacionFiscal: async () => {
      const facturaId = Number(get().ResultadoVenta?.facturaId) || 0;
      if (!facturaId || get().CargandoComprobacionFiscal) return false;
      set({ CargandoComprobacionFiscal: true, ComprobacionFiscal: null });
      try {
        const respuesta = await obtenerFacturaHistorial({
          EmpresaId: useStoreHome.getState().EmpresaId,
          FacturaId: facturaId,
        });
        const comprobacion = analizarComprobacionFiscal(respuesta.data || { Error: respuesta.error });
        set({ ComprobacionFiscal: comprobacion });
        return Boolean(comprobacion.Factura) && !comprobacion.Error;
      } finally {
        set({ CargandoComprobacionFiscal: false });
      }
    },

    reintentarVentaPendiente: async () => {
      const pendiente = obtenerVentaPendiente();
      if (!pendiente?.request || !pendiente?.clave || ventaEnCurso || get().ConfirmandoVenta) return false;
      let sesionCaja = useStoreCajas.getState().sesionActiva;
      if (!sesionAbierta(sesionCaja)) sesionCaja = await useStoreCajas.getState().resolverCaja();
      const cajaSesionPendiente = Number(pendiente.request.cajaSesionId) || 0;
      const cajaSesionActual = Number(sesionCaja?.id ?? sesionCaja?.Id) || 0;
      if (!sesionAbierta(sesionCaja) || cajaSesionPendiente <= 0 || cajaSesionPendiente !== cajaSesionActual) {
        useStoreCajas.setState({ aperturaRequerida: false });
        MensajeError("La venta pendiente pertenece a otra sesion de caja y no puede reenviarse desde la sesion actual.");
        return false;
      }
      ventaEnCurso = true;
      set({ ConfirmandoVenta: true, EstadoEnvioVenta: "enviando", ErrorFiscal: "" });
      try {
        const data = await insertarVenta({ ...pendiente.request, ClaveIdempotencia: pendiente.clave });
        if (data.error) {
          if (esErrorSesionCaja(data.error)) {
            useStoreCajas.getState().limpiarSesion();
            useStoreCajas.setState({ error: data.error, aperturaRequerida: false });
          }
          const esErrorConexion = data.esErrorRed || /conect|network|fetch|timeout|aborted/i.test(data.error);
          set({ EstadoEnvioVenta: esErrorConexion ? "incierto" : "error", ErrorFiscal: data.error });
          MensajeError(data.error);
          return false;
        }
        const resultado = normalizarResultadoVenta(data.data);
        const ventaBase = pendiente.resultado?.venta || pendiente.request.oEntrada;
        const venta = aplicarResultadoStockVenta({
          ...ventaBase,
          VentaId: resultado.ventaId || ventaBase?.VentaId,
          DetalleIds: resultado.detalleIds?.length ? resultado.detalleIds : ventaBase?.DetalleIds,
        }, resultado.detalleStock);
        const resultadoCompleto = { ...pendiente.resultado, ...resultado, venta };
        const actualizado = guardarResultadoPendiente(pendiente, resultadoCompleto);
        set({
          VentaPendiente: actualizado,
          ResultadoVenta: resultadoCompleto,
          UltimaVenta: venta,
          VentasRecientes: agregarVentaReciente(get().VentasRecientes, venta),
          EstadoEnvioVenta: "confirmada",
          EstadoComercialVenta: resultado.estadoVenta,
          EstadoFacturaLocal: estadoFacturaLocalDesdeResultado(resultado),
          EstadoArca: resultado.estadoFactura,
          ErrorFiscal: resultado.ultimoError || resultado.error,
        });
        return true;
      } finally {
        ventaEnCurso = false;
        set({ ConfirmandoVenta: false });
      }
    },

    emitirArca: async (facturaId) => {
      const id = Number(facturaId) || 0;
      if (!id || facturasReintentando.has(id)) return false;
      facturasReintentando.add(id);
      set({
        EstadoArca: ESTADOS_ARCA.ENVIANDO,
        ErrorFiscal: "",
        FacturasReintentando: [...facturasReintentando],
      });
      try {
        const data = await emitirFacturaElectronica({
          EmpresaId: useStoreHome.getState().EmpresaId,
          facturaId: id,
          operadorId: getOperadorId(),
          pcId: getPcId(),
        });
        if (data.error) {
          const consulta = await consultarEstadoFactura({
            EmpresaId: useStoreHome.getState().EmpresaId,
            facturaId: id,
          });
          if (!consulta.error) {
            const estadoConsultado = normalizarEstadoFiscal(consulta.data, ESTADOS_ARCA.ERROR);
            set({
              EstadoArca: estadoConsultado.estado,
              ErrorFiscal: mensajeSeguro(estadoConsultado.error || estadoConsultado.mensaje, estadoConsultado.estado === ESTADOS_ARCA.AUTORIZADA ? "" : "ARCA no pudo autorizar la factura."),
              ResultadoVenta: get().ResultadoVenta
                ? { ...get().ResultadoVenta, estadoFactura: estadoConsultado.estado, usuarioFiscalId: estadoConsultado.usuarioId }
                : null,
            });
            return estadoConsultado.estado === ESTADOS_ARCA.AUTORIZADA;
          }
          set({ EstadoArca: ESTADOS_ARCA.ERROR, ErrorFiscal: mensajeSeguro(data.error, "ARCA no pudo autorizar la factura.") });
          return false;
        }
        const fiscal = normalizarEstadoFiscal(data.data, ESTADOS_ARCA.ERROR);
        set({
          EstadoArca: fiscal.estado,
          ErrorFiscal: mensajeSeguro(fiscal.error || fiscal.mensaje, fiscal.estado === ESTADOS_ARCA.AUTORIZADA ? "" : "ARCA no pudo autorizar la factura."),
          ResultadoVenta: get().ResultadoVenta
            ? { ...get().ResultadoVenta, estadoFactura: fiscal.estado, usuarioFiscalId: fiscal.usuarioId }
            : null,
        });
        return fiscal.estado === ESTADOS_ARCA.AUTORIZADA;
      } finally {
        facturasReintentando.delete(id);
        set({ FacturasReintentando: [...facturasReintentando] });
      }
    },

    reintentarArca: async (facturaId) => {
      const id = Number(facturaId) || 0;
      if (!id || facturasReintentando.has(id)) return false;
      facturasReintentando.add(id);
      const correspondeUltimaVenta = get().ResultadoVenta?.facturaId === id;
      set({
        ...(correspondeUltimaVenta ? { EstadoArca: ESTADOS_ARCA.ENVIANDO, ErrorFiscal: "" } : {}),
        FacturasReintentando: [...facturasReintentando],
      });
      try {
        const consulta = await consultarEstadoFactura({
          EmpresaId: useStoreHome.getState().EmpresaId,
          facturaId: id,
        });
        if (!consulta.error) {
          const estadoActual = normalizarEstadoFiscal(consulta.data);
          if (estadoActual.estado === ESTADOS_ARCA.AUTORIZADA) {
            if (correspondeUltimaVenta) {
              set({
                EstadoArca: ESTADOS_ARCA.AUTORIZADA,
                ErrorFiscal: "",
                ResultadoVenta: { ...get().ResultadoVenta, estadoFactura: ESTADOS_ARCA.AUTORIZADA, usuarioFiscalId: estadoActual.usuarioId },
              });
            }
            await get().cargarPendientesArca(true);
            return true;
          }
        }
        const data = await reintentarFacturaElectronica({
          EmpresaId: useStoreHome.getState().EmpresaId,
          facturaId: id,
          operadorId: getOperadorId(),
          pcId: getPcId(),
        });
        if (data.error) {
          if (correspondeUltimaVenta) set({ EstadoArca: ESTADOS_ARCA.ERROR, ErrorFiscal: mensajeSeguro(data.error, "ARCA no pudo autorizar la factura.") });
          return false;
        }
        const fiscal = normalizarEstadoFiscal(data.data, ESTADOS_ARCA.ERROR);
        set({
          ...(correspondeUltimaVenta ? {
            EstadoArca: fiscal.estado,
            ErrorFiscal: mensajeSeguro(fiscal.error || fiscal.mensaje, fiscal.estado === ESTADOS_ARCA.AUTORIZADA ? "" : "ARCA no pudo autorizar la factura."),
          } : {}),
          ResultadoVenta: get().ResultadoVenta?.facturaId === id
            ? { ...get().ResultadoVenta, estadoFactura: fiscal.estado, usuarioFiscalId: fiscal.usuarioId }
            : get().ResultadoVenta,
        });
        await get().cargarPendientesArca(true);
        return fiscal.estado === ESTADOS_ARCA.AUTORIZADA;
      } finally {
        facturasReintentando.delete(id);
        set({ FacturasReintentando: [...facturasReintentando] });
      }
    },

    cargarPendientesArca: async (silencioso = false) => {
      if (get().CargandoPendientesArca) return;
      set({ CargandoPendientesArca: true });
      try {
        const data = await obtenerPendientesArca(useStoreHome.getState().EmpresaId);
        if (data.error) {
          if (!silencioso) MensajeError(mensajeSeguro(data.error, "No se pudo cargar la facturacion pendiente."));
          return;
        }
        const contenido = data.data || {};
        const lista = contenido.Lista || contenido.lista || contenido.Pendientes || contenido.pendientes || (Array.isArray(contenido) ? contenido : []);
        set({ PendientesArca: Array.isArray(lista) ? lista : [] });
      } finally {
        set({ CargandoPendientesArca: false });
      }
    },

    descargarA4: async (facturaId) => {
      if (get().DescargandoComprobante) return;
      set({ DescargandoComprobante: true });
      try {
        const data = await descargarComprobante({
          EmpresaId: useStoreHome.getState().EmpresaId,
          facturaId,
          formato: "A4",
        });
        if (data.error) return MensajeError(mensajeSeguro(data.error, "No se pudo descargar el comprobante."));
        guardarArchivo(data.data, `factura-${facturaId}.pdf`);
      } finally {
        set({ DescargandoComprobante: false });
      }
    },

    imprimirTicket: async (facturaId) => {
      if (get().ImprimiendoComprobante) return;
      const ventana = window.open("", "_blank");
      set({ ImprimiendoComprobante: true });
      try {
        const datos = await obtenerComprobanteDatos({
          EmpresaId: useStoreHome.getState().EmpresaId,
          facturaId,
          formato: "Ticket80",
        });
        if (datos.error) {
          ventana?.close();
          MensajeError(mensajeSeguro(datos.error, "No se pudo preparar el ticket."));
          return;
        }
        const contenido = datos.data?.html || datos.data?.Html || datos.data?.contenido || datos.data?.Contenido;
        if (ventana && contenido) {
          ventana.document.write(String(contenido));
          ventana.document.close();
          ventana.focus();
          ventana.print();
          return;
        }
        const pdf = await descargarComprobante({
          EmpresaId: useStoreHome.getState().EmpresaId,
          facturaId,
          formato: "Ticket80",
        });
        if (pdf.error) {
          ventana?.close();
          return MensajeError(mensajeSeguro(pdf.error, "No se pudo preparar el ticket."));
        }
        const url = URL.createObjectURL(pdf.data);
        if (ventana) ventana.location.href = url;
        else window.open(url, "_blank");
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      } finally {
        set({ ImprimiendoComprobante: false });
      }
    },

    // ---------- Lista de Precios ----------
    ListaPreciosId: 0,
    ListaPreciosEditable: [],
    ListaPreciosOriginal: {},
    CargandoListaPrecios: false,
    GuardandoListaPrecios: false,
    cargarListaPreciosEditable: async () => {
      if (!useStoreHome.getState().EmpresaId || get().CargandoListaPrecios) return;
      const EmpresaId = useStoreHome.getState().EmpresaId;
      set({ CargandoListaPrecios: true });
      try {
        const dataListas = await listarListasPrecios(EmpresaId, false);
        if (dataListas.error) {
          MensajeError(dataListas.error);
          return;
        }

        const oListaGeneral = (dataListas.data.Lista || []).find((l) => l.sDescripcion === "Lista General");
        const iListaId = oListaGeneral ? oListaGeneral.Id : 0;

        let lstAsignadas = [];
        if (iListaId > 0) {
          const dataAsignadas = await obtenerMercaderiasLista(EmpresaId, iListaId);
          if (dataAsignadas.error) {
            MensajeError(dataAsignadas.error);
            return;
          }
          lstAsignadas = dataAsignadas.data.ListaAsignadas || [];
        }

        // La lista del buscador del POS contiene solo los resultados de la
        // búsqueda actual. No debe reutilizarse como si fuera el catálogo:
        // seleccionar un producto allí dejaba la lista de precios con un único
        // elemento. Cargamos el catálogo de forma independiente para no pisar
        // tampoco los resultados visibles en el POS.
        const dataCatalogo = await listarCatalogoMercaderias({ EmpresaId });
        if (dataCatalogo.error) {
          MensajeError(dataCatalogo.error);
          return;
        }
        const lstCatalogo = dataCatalogo.data?.Lista || [];

        const lstEditable = lstCatalogo.map((m) => {
          const oAsignado = lstAsignadas.find((a) => a.Id === m.Id);
          return {
            Id: m.Id,
            sCodigo: m.sCodigo,
            sDescripcion: m.sDescripcion,
            nPrecio: oAsignado ? Number(oAsignado.nPrecio) : 0,
            MonedaTipo_Id: oAsignado ? oAsignado.MonedaTipo_Id : 1,
          };
        });

        set({
          ListaPreciosId: iListaId,
          ListaPreciosEditable: lstEditable,
          ListaPreciosOriginal: Object.fromEntries(
            lstEditable.map((producto) => [producto.sCodigo, Number(producto.nPrecio) || 0]),
          ),
        });
      } catch (error) {
        MensajeError(error.message);
      } finally {
        set({ CargandoListaPrecios: false });
      }
    },

    setPrecioProductoEditable: (id, nuevoPrecio) => {
      set({
        ListaPreciosEditable: get().ListaPreciosEditable.map((p) =>
          p.Id === id ? { ...p, nPrecio: nuevoPrecio } : p
        ),
      });
    },

    guardarListaPrecios: async () => {
      const st = get();
      if (st.GuardandoListaPrecios) return false;
      if (!st.ListaPreciosId) {
        MensajeError("No se encontró la Lista General.");
        return false;
      }
      set({ GuardandoListaPrecios: true });
      try {
        const EmpresaId = useStoreHome.getState().EmpresaId;
        const cambios = {
          // El servidor espera la colección en la propiedad "Precios".
          Precios: st.ListaPreciosEditable
            .filter((p) =>
              (Number(p.nPrecio) || 0) !== (Number(st.ListaPreciosOriginal[p.sCodigo]) || 0)
            )
            .map((p) => ({
            Codigo: p.sCodigo || "",
            Precio: Number(p.nPrecio) || 0,
            })),
        };

        if (cambios.Precios.length === 0) {
          MensajeInfo("No hay cambios de precios para guardar.");
          return true;
        }

        const data = await actualizarPreciosRapidos({
          EmpresaId,
          ListaId: st.ListaPreciosId,
          precios: cambios.Precios,
        });
        if (data.error) {
          MensajeError(data.error);
          return false;
        }

        set({
          ListaPreciosOriginal: Object.fromEntries(
            st.ListaPreciosEditable.map((producto) => [
              producto.sCodigo,
              Number(producto.nPrecio) || 0,
            ]),
          ),
        });
        MensajeToastExito("Lista de precios guardada correctamente.");
        return true;
      } catch (error) {
        MensajeError(error.message);
        return false;
      } finally {
        set({ GuardandoListaPrecios: false });
      }
    },
  };
});
